function handleEventListeners(events = [], type = "add") {
  const evts = Array.isArray(events) ? events : [events];
  for (const evt of evts) {
    const evt_types = Array.isArray(evt.type) ? evt.type : [evt.type];
    if (type === "add") {
      for (const evt_type of evt_types) {
        evt.el.addEventListener(evt_type, evt.callback);
      }
    } else {
      for (const evt_type of evt_types) {
        evt.el.removeEventListener(evt_type, evt.callback);
      }
    }
  }
}
window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this),
    );
  },
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function () {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this),
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "£{{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || "";

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/,
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};

        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

/*================ MODULES ================*/
window.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.nodes = {
      $parent: $("body, html"),
      $page: $(".page-element"),
      $moved: $(".is-moved-by-drawer"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    this.$open.attr("aria-expanded", "false");
    this.$open.on("click", $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass("is-transitioning");
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function () {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "false");
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this),
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this),
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

theme.Hero = (function () {
  var selectors = {
    hero: ".hero",
    heroWrapper: ".hero-wrapper",
    heroContent: ".hero-content",
    heroTitle: ".hero-content__title",
    heroPause: ".hero__pause",
    heroAdapt: ".hero--adapt",
    heroControlsArrow: ".hero-content__controls-item--arrow",
    heroControlsCount: ".hero-content__controls-item--count",
    heroControlsText: ".hero-content__controls-item--text",
  };

  var classes = {
    heroContentActive: "hero-content-active",
    heroTitleActive: "hero-title-active",
    heroLinkActive: "hero-link-active",
    isPaused: "is-paused",
  };

  function Hero(sectionId) {
    this.namespace = ".hero";
    this.$hero = $(sectionId);
    this.$wrapper = this.$hero.closest(selectors.heroWrapper);
    this.$heroContent = this.$wrapper.find(selectors.heroContent);
    this.$heroPause = this.$wrapper.find(selectors.heroPause);
    this.$heroControlsArrow = this.$wrapper.find(selectors.heroControlsArrow);
    this.$heroAdapt = this.$wrapper.find(selectors.heroAdapt);

    this.$hero.on("init" + this.namespace, this._a11y.bind(this));
    this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this));
    this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this));
    this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this));
    this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this));
    this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));

    var adaptHeight = this.$hero.data("adapt-height");

    this.$hero.slick({
      accessibility: true,
      arrows: false, // this theme has custom arrows
      draggable: false,
      autoplay: this.$hero.data("autoplay"),
      autoplaySpeed: this.$hero.data("speed"),
    });

    if (adaptHeight) {
      this._setSlideshowHeight();
      $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)));
    }

    this.$heroPause.on("click" + this.namespace, this._togglePause.bind(this));
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    _setSlideshowHeight: function () {
      var minAspectRatio = this.$hero.data("min-aspect-ratio");
      this.$hero.height(this.$heroAdapt.width() / minAspectRatio);
    },

    _countSlide: function (event, slick, currentSlide) {
      // currentSlide is undefined on init,
      // set it to 0 in this case (currentSlide is 0 based)
      var activeSlide = (currentSlide ? currentSlide : 0) + 1;
      var $heroControlsCount = this.$wrapper.find(selectors.heroControlsCount);

      if (slick.slideCount > 1) {
        $heroControlsCount.attr(
          "aria-label",
          theme.strings.slideNumber.replace("[slide_number]", activeSlide),
        );
        $heroControlsCount.children(".slide-counter").text(activeSlide + "/" + slick.slideCount);
      }
    },

    _showActiveContent: function (event, slick, currentSlide) {
      // currentSlide is undefined on init,
      // set it to 0 in this case (currentSlide is 0 based)
      // eslint-disable-next-line
      var currentSlide = currentSlide || 0;
      var $heroControlsText = this.$wrapper.find(selectors.heroControlsText);
      var $heroTitle = this.$wrapper.find(selectors.heroTitle);

      if (slick.slideCount > 1) {
        var $currentTitle = $heroTitle.filter('[data-slide-id="' + (currentSlide + 1) + '"]'),
          $currentLink = $heroControlsText.filter('[data-slide-id="' + (currentSlide + 1) + '"]');

        $heroTitle.removeClass(classes.heroTitleActive);
        $currentTitle.addClass(classes.heroTitleActive);
        $heroControlsText.removeClass(classes.heroLinkActive);
        $currentLink.addClass(classes.heroLinkActive);
      }
    },

    _hideContent: function () {
      this.$heroContent.removeClass(classes.heroContentActive);
    },

    _showContent: function () {
      this.$heroContent.addClass(classes.heroContentActive);
    },

    _togglePause: function () {
      if (this.$heroPause.hasClass(classes.isPaused)) {
        var labelPause = this.$heroPause.data("label-pause");
        this.$heroPause.removeClass(classes.isPaused).attr({
          "aria-pressed": "false",
          "aria-label": labelPause,
        });
        this.play();
      } else {
        var labelPlay = this.$heroPause.data("label-play");
        this.$heroPause.addClass(classes.isPaused).attr({
          "aria-pressed": "true",
          "aria-label": labelPlay,
        });
        this.pause();
      }
    },

    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $heroWrapper = $(event.currentTarget).parents(selectors.heroWrapper);
      var autoplay = this.$hero.data("autoplay");

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");
      this.$heroContent.removeAttr("aria-live");

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $heroWrapper
        .on(
          "focusin" + this.namespace,
          function (evt) {
            if (!$heroWrapper.has(evt.target).length) {
              return;
            }

            this.$heroContent.attr("aria-live", "polite");
            if (autoplay) {
              this.pause();
            }
          }.bind(this),
        )
        .on(
          // Resume autoplay
          "focusout" + this.namespace,
          function (evt) {
            if ($heroWrapper.has(evt.relatedTarget).length) {
              return;
            }

            this.$heroContent.removeAttr("aria-live");

            if (autoplay && !this.$heroPause.hasClass(classes.isPaused)) {
              // Only resume playing if the user hasn't paused using the pause
              // button
              this.play();
            }
          }.bind(this),
        )
        .on("keyup", this._keyboardNavigation.bind(this));
    },

    _arrowsInit: function (event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = this.$heroControlsArrow;

      if ($arrows.length && count > 1) {
        $arrows.on(
          "click" + this.namespace,
          function (evt) {
            evt.preventDefault();
            var $arrowButton = $(evt.currentTarget).find("button");
            var arrowButtonControl = $arrowButton.data("control");
            if (arrowButtonControl === "previous") {
              $slider.slick("slickPrev");
            } else if (arrowButtonControl === "next") {
              $slider.slick("slickNext");
            }
            this._scrollTop();
          }.bind(this),
        );
      } else {
        $arrows.remove();
      }
    },

    _scrollTop: function () {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;

      if (currentScroll > heroOffset) {
        $("html").add("body").animate(
          {
            scrollTop: heroOffset,
          },
          250,
        );
      }
    },

    _keyboardNavigation: function (event) {
      if (event.keyCode === 37) {
        this.$hero.slick("slickPrev");
      }
      if (event.keyCode === 39) {
        this.$hero.slick("slickNext");
      }
    },

    goToSlide: function (slideIndex) {
      this.$hero.slick("slickGoTo", slideIndex);
    },

    pause: function () {
      if (!this.$hero.data("autoplay")) return;
      this.$hero.slick("slickPause");
    },

    play: function () {
      if (!this.$hero.data("autoplay")) return;
      this.$hero.slick("slickPlay");
    },

    destroy: function () {
      this.$hero.off(this.namespace);
      this.$heroContent.off(this.namespace);
      this.$heroPause.off(this.namespace);
      this.$wrapper.off(this.namespace);
      this.$heroControlsArrow.off(this.namespace);
      this.$heroAdapt.off(this.namespace);

      this.$hero.slick("unslick");
    },
  });

  return Hero;
})();

window.Modals = (function () {
  var Modal = function (id, name, options) {
    var defaults = {
      close: ".js-modal-close",
      open: ".js-modal-open-" + name,
      openClass: "modal--is-active",
    };

    this.$modal = $("#" + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $("body"),
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  };

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr("aria-expanded", "false");

    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$modal.find(this.config.close).on("click", $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: "modal_focus",
      $elementToFocus: this.$focusOnOpen,
    });

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: "modal_focus",
    });

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "false").focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$body.on(
      "keyup.modal",
      $.proxy(function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this),
    );
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$body.off(".modal");
  };

  return Modal;
})();

window.Meganav = (function () {
  var Meganav = function (options) {
    this.cache = {
      $document: $(document),
      $page: $(".page-element"),
    };

    var defaults = {
      $meganavs: $(".meganav"),
      $megaNav: $(".meganav__nav"),
      $meganavToggle: $(".meganav-toggle"),
      $meganavDropdownContainers: $(".site-nav__dropdown-container"),
      $meganavToggleThirdLevel: $(".meganav__link-toggle"),
      $meganavLinkSecondLevel: $(".meganav__link--second-level"),
      $meganavLinkThirdLevel: $(".meganav__link--third-level"),
      $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: "meganav--active",
      drawerClass: "meganav--drawer",
      meganavDropdown: ".site-nav__dropdown",
      meganavLinkClass: "meganav__link",
      drawerToggleClass: "drawer__nav-toggle-btn",
      drawerNavItem: ".drawer__nav-item",
      navCollectionClass: "meganav__nav--collection",
      secondLevelClass: "meganav__link--second-level",
      thirdLevelClass: "meganav__link-toggle",
      thirdLevelContainerClass: "site-nav__dropdown--third-level",
      noAnimationClass: "meganav--no-animation",
    };
    this.config = $.extend(defaults, options);
    this.init();
  };

  Meganav.prototype.init = function () {
    var $openBtn = this.config.$meganavToggle;

    $openBtn.on("click", $.proxy(this.requestMeganav, this));

    if (this.config.closeThirdLevelOnBlur) {
      this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this));
    }
  };

  Meganav.prototype.requestMeganav = function (evt) {
    var $targetedMeganav;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    // The $targetedMeganav is different for the drawer and non-drawer navs
    if ($el.hasClass(this.config.drawerToggleClass)) {
      $targetedMeganav = $el
        .closest(this.config.drawerNavItem)
        .children("." + this.config.drawerClass);
    } else {
      $targetedMeganav = $el.siblings(this.config.meganavDropdown);
    }

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass) && $el.is("a")) {
      window.location = $el.attr("href");
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if ($targetedMeganav.hasClass(this.config.drawerClass)) {
      var isExpanded = $el.attr("aria-expanded") === "true";

      $el.toggleClass(this.config.activeClass).attr("aria-expanded", !isExpanded);

      $targetedMeganav.stop().slideToggle(200);
    } else {
      $el.addClass(this.config.activeClass).attr("aria-expanded", "true");

      // Show targeted nav, letting it know whether another meganav is already open
      this.open($el, $targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;

    // If dropdown has third level, calculate width for container
    var $dropdown = $el.next();
    var isCollection = $dropdown
      .find(this.config.$megaNav)
      .hasClass(this.config.navCollectionClass);

    if (isCollection) {
      this.updateThirdLevelContainerWidth($el, $dropdown);
    }
  };

  Meganav.prototype.updateThirdLevelContainerWidth = function ($el, $dropdown) {
    var $thirdLevel = $dropdown.find(this.config.$meganavDropdownThirdLevel);

    if (!$thirdLevel.length) {
      return;
    }

    $.each(
      $thirdLevel,
      function (key, container) {
        var $container = $(container);
        var $lastChild = $container.find("li:last-child");

        this.updateContainerWidth($container, $lastChild);
      }.bind(this),
    );
  };

  Meganav.prototype.updateContainerWidth = function (container, element) {
    var containerRect = container[0].getBoundingClientRect();
    var elementRect = element[0].getBoundingClientRect();

    if (elementRect.left < containerRect.right) {
      return;
    }

    var columnWidth = containerRect.width;
    var containerFixedWidth = elementRect.left + columnWidth - containerRect.left;
    var numberOfColumns = containerFixedWidth / columnWidth;
    var containerPercentageWidth = numberOfColumns * 20;

    container
      .width(containerPercentageWidth + "%")
      .find("li")
      .css("width", 100 / numberOfColumns + "%");
  };

  Meganav.prototype.open = function ($el, $target, noAnimation) {
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    $target.addClass(this.config.activeClass);

    if (isThirdLevelBtn) {
      this.toggleSubNav($el, $target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function ($el) {
    this.removeMenuActiveState();

    $el
      .addClass(this.config.activeClass)
      .attr("aria-expanded", "true")
      .siblings(this.config.$meganavDropdownThirdLevel)
      .addClass(this.config.activeClass);

    $el.parent().addClass(this.config.activeClass);
  };

  Meganav.prototype.close = function (evt, $target) {
    if (this.config.preventDuplicates) {
      // Close all meganavs
      this.config.$meganavs.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(" "),
      );
      this.config.$meganavToggle
        .removeClass(this.config.activeClass)
        .attr("aria-expanded", "false");

      this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
    } else {
      // Close targeted nav
      var $targetedMeganav = $("#" + $target.attr("aria-controls"));
      $targetedMeganav.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(" "),
      );
      $target.removeClass(this.config.activeClass).attr("aria-expanded", "false");
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function (evt) {
    var $el = $(evt.currentTarget);
    var $parent = $el.parent();

    if (!$parent.is(":last-child")) {
      return;
    }

    this.config.$meganavLinkSecondLevel.one(
      "focus.meganav",
      $.proxy(function () {
        this.removeMenuActiveState();
      }, this),
    );
  };

  Meganav.prototype.removeMenuActiveState = function () {
    var activeClasses = [this.config.activeClass, this.config.noAnimationClass];

    this.config.$meganavToggleThirdLevel
      .removeClass(activeClasses.join(" "))
      .attr("aria-expanded", "false");

    this.config.$meganavDropdownThirdLevel.removeClass(activeClasses.join(" "));
    this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
  };

  Meganav.prototype.bindEvents = function () {
    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on("click.meganav", $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on(
      "click.meganav",
      function (evt) {
        // 3rd level container
        var is3rdLevelMenuTarget =
          $(evt.currentTarget).hasClass(this.config.activeClass) &&
          $(evt.currentTarget).hasClass(this.config.thirdLevelContainerClass);

        // 2nd level mega link
        var isMegaNavlink =
          $(evt.target).hasClass(this.config.meganavLinkClass) &&
          $(evt.target).hasClass(this.config.secondLevelClass);

        // If we click anything outside from the 3rd level megaNav, close the third level menu (except for 2nd level links)
        if (!is3rdLevelMenuTarget && !isMegaNavlink) {
          this.removeMenuActiveState();
        }

        evt.stopImmediatePropagation();
      }.bind(this),
    );

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on(
      "keyup.meganav",
      $.proxy(function (evt) {
        if (evt.keyCode !== 27) return;

        this.config.$meganavToggle.filter("." + this.config.activeClass).focus();
        this.close();
      }, this),
    );
  };

  Meganav.prototype.unbindEvents = function () {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off(".meganav");
    this.config.$meganavs.off(".meganav");
    this.cache.$document.off(".meganav");
    this.config.$meganavLinkSecondLevel.off(".meganav");
    this.config.$meganavLinkThirdLevel.off(".meganav");
  };

  return Meganav;
})();

window.QtySelector = (function () {
  var QtySelector = function ($el) {
    this.cache = {
      $body: $("body"),
      $subtotal: $("#CartSubtotal"),
      $discountTotal: $("#cartDiscountTotal"),
      $cartTable: $(".cart-table"),
      $cartTemplate: $("#CartProducts"),
      $cartFooter: $("#CartFooter"),
      $cartFooterTemplate: $("#CartFooterTemplate"),
    };

    this.settings = {
      loadingClass: "js-qty--is-loading",
      isCartTemplate: this.cache.$body.hasClass("template-cart"),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1,
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function () {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr("id"),
      name: $el.attr("name"),
      line: $el.attr("data-line"),
    };
    var source = $("#QuantityTemplate").html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function (line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: "GET",
      url: "/products/" + handle + ".js",
      dataType: "json",
      success: $.proxy(function (cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this),
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function (line, quantity, id, product) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (variant.inventory_management !== null && variant.inventory_policy === "deny") {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
        theme.Notify.open("error", theme.strings.noStockAvailable, true);

        // Set quantity to max amount available
        this.$wrapper.find(".js-qty__input").val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function (evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings(".js-qty__input");
    var qty = this.validateQty($input.val());
    var line = $input.attr("data-line");

    if ($el.hasClass("js-qty__adjust--minus")) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    $input.attr("value", qty);

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function () {
    this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on("click", ".js-qty__input", function () {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        "change",
        ".js-qty__input",
        $.proxy(function (evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr("data-line");
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this),
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function (line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function () {
        this.validateAvailability(line, qty);
      }, this),
      200,
    );
  };

  QtySelector.prototype.updateItemQuantity = function (line, quantity) {
    var params = {
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: $.proxy(function (cart) {
        this.updateCartItemCallback(cart);
      }, this),
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function (cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $("#CartProductTemplate").html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      } else {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", "");
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === "_" || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[discount].formattedAmount =
            theme.Currency.formatMoney(amount, theme.moneyFormat);
        }
      }

      var unitPrice = null;
      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
          price: theme.Currency.formatMoney(cartItem.unit_price, theme.moneyFormat),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit,
        };
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
        linePrice: theme.Currency.formatMoney(cartItem.final_line_price, theme.moneyFormat),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat,
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
    };
    this.cache.$cartTemplate.empty().append(template(data));

    this.updateCartFooter(cart);

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function (i, el) {
      new QtySelector($(el));
    });

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  QtySelector.prototype.updateCartFooter = function (cart) {
    if (cart.cart_level_discount_applications.length !== 0) {
      for (var cartDiscount in cart.cart_level_discount_applications) {
        var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;

        cart.cart_level_discount_applications[cartDiscount].formattedAmount =
          theme.Currency.formatMoney(cartAmount, theme.moneyFormat);
      }
    }

    var source = this.cache.$cartFooterTemplate.html();
    var template = Handlebars.compile(source);
    var data = {
      totalPrice: theme.Currency.formatMoney(cart.total_price, theme.moneyFormat),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
    };

    this.cache.$cartFooter.empty().append(template(data));
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function () {
  var cart = function ($form) {
    this.cache = {
      $cartIconIndicator: $(".site-header__cart-indicator"),
    };

    this.$form = $form;
    this.eventListeners();
  };

  cart.prototype.eventListeners = function () {
    if (this.$form.length) {
      this.$form.on("submit", $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function (evt) {
    evt.preventDefault();

    var params = {
      type: "POST",
      url: "/cart/add.js",
      data: this.$form.serialize(),
      dataType: "json",
      success: $.proxy(function (lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function (XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this),
    };

    $.ajax(params);
  };

  cart.prototype.success = function () {
    theme.Notify.open("success", false, true);

    // Update cart notification bubble's state
    var currentValue = $(".site-header__cart-indicator").text();
    var newValue = +currentValue + 1;
    $(".site-header__cart-indicator").text(newValue);
    this.cache.$cartIconIndicator.removeClass("hide");

    var $el = $("#AddToCart-product-template").addClass("active");

    setTimeout(function () {
      $el.removeClass("active");
    }, 2000);
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function (XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      theme.Notify.open("error", data.description, true);
    }
  };

  return cart;
})();

window.Notify = (function () {
  var notify = function () {
    this.cache = {
      $scrollParent: $("html").add("body"),
      $notificationSuccess: $("#NotificationSuccess"),
      $notificationSuccessLink: $("#NotificationSuccess").find("a"),
      $notificationError: $("#NotificationError"),
      $notificationPromo: $("#NotificationPromo"),
      $notificationClose: $(".notification__close"),
      $notificationErrorMessage: $(".notification__message--error"),
    };

    this.settings = {
      notifyActiveClass: "notification--active",
      closeTimer: 5000,
      promoKeyName: "promo-" + this.cache.$notificationPromo.data("text"),
    };

    this.notifyTimer;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();

    this.cache.$notificationClose.on("click", this.close.bind(this));
    this.showPromo();
    this.adaptNotification();
  };

  function isLocalStorageSupported() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  notify.prototype.open = function (state, message, autoclose) {
    this.close();

    if (state === "success") {
      this.cache.$notificationSuccess
        .attr("aria-hidden", false)
        .addClass(this.settings.notifyActiveClass);

      // Set last focused element to return to once success
      // notification is dismissed (by timeout)
      this.$lastFocusedElement = $(document.activeElement);

      // Set focus on link to cart after transition
      this.cache.$notificationSuccess.one(
        "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
        $.proxy(function () {
          slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
        }, this),
      );

      // Fallback for no transitions
      if (this.cache.$scrollParent.hasClass("no-csstransitions")) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError
        .attr("aria-hidden", false)
        .addClass(this.settings.notifyActiveClass);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer);
    }
  };

  notify.prototype.close = function (evt) {
    if (evt && $(evt.currentTarget).attr("id") === "NotificationPromoClose") {
      if (this.isLocalStorageSupported) {
        localStorage.setItem(this.settings.promoKeyName, "hidden");
      }
    }

    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link
    if (this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus")) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }

    // Close all notification bars
    this.cache.$notificationSuccess
      .attr("aria-hidden", true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError
      .attr("aria-hidden", true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationPromo
      .attr("aria-hidden", true)
      .removeClass(this.settings.notifyActiveClass);

    // Reset last focused element
    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function (SFEevent) {
    // If reloaded in the storefront editor, update selectors/settings
    if (SFEevent) {
      this.initCache();
    }

    if (this.isLocalStorageSupported && localStorage[this.settings.promoKeyName] === "hidden") {
      return;
    }

    this.cache.$notificationPromo
      .attr("aria-hidden", false)
      .addClass(this.settings.notifyActiveClass);
  };

  notify.prototype.adaptNotification = function () {
    var adaptHeight = $(".hero").data("adapt-height"),
      $notification = $("#NotificationPromo"),
      $notificationInner = $notification.children(".notification__inner");

    if (!$notification.length) {
      return;
    }

    $notification.toggleClass("notification-adapt page-width", adaptHeight === true);
    $notificationInner.toggleClass("page-width", adaptHeight === false);
  };

  return notify;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass("page-width map-section--load-error");
  theme.$currentMapContainer.find(".map-section__content-wrapper").remove();
  theme.$currentMapContainer
    .find(".map-section__wrapper")
    .html(
      '<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + "</div>",
    );
}

theme.headerNav = (function () {
  var selectors = {
    siteNav: "#SiteNav",
    siteNavCompressed: "#SiteNavCompressed",
    siteNavParent: "#SiteNavParent",
    siteNavItem: ".site-nav__item",
  };

  var config = {
    lastScroll: 0,
    isActive: false,
    searchInputClass: "site-header__search-input",
    searchSubmitClass: "site-header__search-submit",
    searchInnerActiveClass: "search-header__search-inner--active",
  };

  function init() {
    initMegaNavs();
    initHeaderSearch();
  }

  function initMegaNavs() {
    new window.Meganav({
      $meganavs: $(".site-nav__dropdown"),
      $meganavToggle: $(".site-nav__link-toggle"),
      preventDuplicates: true,
      closeOnPageClick: true,
      closeThirdLevelOnBlur: true,
    });

    new window.Meganav({
      $meganavs: $(".meganav--index"),
      $meganavToggle: $(".index__meganav-toggle"),
    });

    new window.Meganav({
      $meganavs: $(".meganav--drawer"),
      $meganavToggle: $(".drawer__meganav-toggle"),
    });
  }

  function initHeaderSearch() {
    // This function runs after the header search element
    // is duplicated into the sticky nav, meaning there are
    // two search fields to be aware of at this point.
    var $searchForm = $(".site-header__search");

    $searchForm.each(function (i, el) {
      var $form = $(el);
      var $input = $form.find("." + config.searchInputClass);
      var $submit = $form.find("." + config.searchSubmitClass);

      $input.add($submit).on("focus blur", function () {
        $form.toggleClass("active-form");
      });

      $submit.on("mousedown", function () {
        if ($form.hasClass("active-form")) {
          $form.submit();
        }
      });
    });
  }

  return {
    init: init,
  };
})();

/*================ TEMPLATES ================*/
theme.customerTemplates = (function () {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$(".reset-password-success").length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew",
      });
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function () {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function () {
      var $el = $(this);
      var addressUrl = $el.data("address-url");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
        Shopify.postLink(addressUrl, {
          parameters: { _method: "delete" },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function () {
  function Header() {
    theme.headerNav.init();
    theme.NavDrawer = new window.Drawers("NavDrawer", "left");
  }

  function drawerSearch() {
    var $headerSearch = $(".search-header");
    var $drawerSearch = $(".drawer__search-input");
    var $drawerSearchSubmit = $(".drawer__search-submit");

    $headerSearch.on("click", function (evt) {
      $drawerSearch.focus();
    });

    $drawerSearchSubmit.on("click", function (evt) {
      if ($drawerSearch.val().length !== 0) {
        return;
      }

      evt.preventDefault();
      $drawerSearch.focus();
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onSelect: function () {
      theme.Notify.adaptNotification();
    },
    onUnload: function () {
      theme.headerNav.unload();
    },
  });

  return Header;
})();

theme.Filters = (function () {
  var selectors = {
    filterSelection: "#SortTags",
    sortSelection: "#SortBy",
  };

  function Filters() {
    this.$filterSelect = $(selectors.filterSelection);
    this.$sortSelect = $(selectors.sortSelection);

    this.$filterSelect.on("change", this._onFilterChange.bind(this));
    this.$sortSelect.on("change", this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onFilterChange: function () {
      location.href = this.$filterSelect.val();
    },

    _onSortChange: function () {
      Shopify.queryParams.sort_by = this.$sortSelect.val();
      if (Shopify.queryParams.page) {
        delete Shopify.queryParams.page;
      }
      location.search = decodeURIComponent($.param(Shopify.queryParams));
    },

    onUnload: function () {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    },
  });

  return Filters;
})();

theme.Product = (function () {
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false,
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    this.selectors = {
      originalSelectorId: "#ProductSelect-" + sectionId,
      modal: "ProductModal",
      productZoomImage: "#ProductZoomImg",
      addToCart: "#AddToCart-" + sectionId,
      productPrice: "#ProductPrice-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      SKU: ".variant-sku",
      productImageContainers: ".product__photo-container-" + sectionId,
      productImageWrappers: ".product__photo-wrapper-" + sectionId,
      productThumbContainers: ".product-single__thumbnail-item-" + sectionId,
      productThumbsWrapper: ".product-single__thumbnails-" + sectionId,
      productThumbs: ".product-single__thumbnail-" + sectionId,
      saleTag: "#ProductSaleTag-" + sectionId,
      productStock: "#ProductStock-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      shopifyPaymentButton: ".shopify-payment-button",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
      unitPriceContainer: "[data-unit-price-container]",
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data("ajax"),
      stockSetting: $container.data("stock"),
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".product-" + sectionId,
    });

    // Stop parsing if we don't have the product json script tag
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($("#ProductJson-" + sectionId).html());
    this.addVariantInfo();
    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function () {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId));
      }
    },

    _stringOverrides: function () {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function () {
      if (!this.productSingleObject) {
        return;
      }

      var variantInfo = JSON.parse($("#VariantJson-" + this.settings.sectionId).html());

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateVariantChange.bind(this),
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this),
      );
      this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this),
      );
    },

    _updateStock: function (variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass("hide");
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(theme.strings.stockAvailable.replace("1", variant.inventory_quantity))
          .removeClass("hide");
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(theme.strings.willNotShipUntil.replace("[date]", variant.next_incoming_date))
          .removeClass("hide");
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass("hide");
    },

    _updateIncomingInfo: function (variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(theme.strings.willBeInStockAfter.replace("[date]", variant.next_incoming_date))
          .removeClass("hide");
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass("hide");
    },

    _updateVariantChange: function (evt) {
      var variant = evt.variant;
      var preOrderMessage = document.querySelector(".preorder-message");
      var preorder_input = document.querySelector('input[name="properties[_preorder]"]');

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText),
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass("btn--sold-out").prop("disabled", false);
          if (variant.inventory_quantity <= 0 && !variant.name.includes("Gift Card")) {
            cache.$addToCartText.html(theme.strings.preOrder);
            preOrderMessage.classList.remove("hide");
            preorder_input.disabled = false;
          } else {
            cache.$addToCartText.html(theme.strings.addToCart);
            preOrderMessage.classList.add("hide");
            preorder_input.disabled = true;
          }
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop("disabled", true).addClass("btn--sold-out");
          cache.$addToCartText.html(theme.strings.soldOut);
          preOrderMessage.classList.add("hide");
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
        }

        $(this.selectors.unitPriceContainer, this.$container).addClass("hide");

        if (variant.unit_price_measurement) {
          var $unitPrice = $(this.selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(this.selectors.unitPriceBaseUnit, this.$container);

          $unitPrice.html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
          $unitPriceBaseUnit.html(this._getBaseUnit(variant));

          $(this.selectors.unitPriceContainer, this.$container).removeClass("hide");
        }
      } else {
        cache.$addToCart.prop("disabled", true).removeClass("btn--sold-out");
        cache.$addToCartText.html(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat),
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
            .removeClass("hide");
          $(this.selectors.saleTag).removeClass("hide");
        } else {
          $(this.selectors.comparePrice).addClass("hide");
          $(this.selectors.saleTag).addClass("hide");
        }
      } else {
        $(this.selectors.comparePrice).addClass("hide");
      }
    },

    _getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var imageId = variant.featured_image.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },

    switchProductImage: function (imageId) {
      var $imageToShow = $(
        this.selectors.productImageContainers + "[data-image-id='" + imageId + "']",
        this.$container,
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers + ":not([data-image-id='" + imageId + "'])",
        this.$container,
      );
      $imagesToHide.addClass("hide");
      $imageToShow.removeClass("hide");
      if ($imageToShow.hasClass("video-slide")) {
        $imageToShow.children("video")[0].play();
      }
      if ($imagesToHide.hasClass("video-slide")) {
        $imagesToHide.children("video")[0].pause();
      }
    },

    setActiveThumbnail: function (imageId) {
      var $thumbnailToShow = $(
        this.selectors.productThumbContainers + "[data-image-id='" + imageId + "']",
        this.$container,
      );
      var $thumbnailsToHide = $(
        this.selectors.productThumbContainers + ":not([data-image-id='" + imageId + "'])",
        this.$container,
      );
      $thumbnailsToHide.removeClass("is-active");
      $thumbnailToShow.addClass("is-active");

      var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass("slick-initialized")) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick("slickCurrentSlide");
        var newActiveSlideIndex = parseInt($thumbnailToShow.attr("data-slick-index"));
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick("slickGoTo", newActiveSlideIndex, false);
        }
      }
    },

    _productZoomImage: function () {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (!$(".product-single " + this.selectors.productImageContainers).length) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function (evt) {
        evt.preventDefault();
        // Empty src before loadig new image to avoid awkward image swap
        $(self.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"));
      });

      this.ProductModal = new window.Modals(this.selectors.modal, "product-modal");

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on("click" + this.settings.namespace, function (evt) {
        if (evt.target.nodeName !== "IMG") {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function () {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on("click" + this.settings.namespace, function (evt) {
        evt.preventDefault();
        var imageId = $(this).parent().data("image-id");
        self.setActiveThumbnail(imageId);
        self.switchProductImage(imageId);
      });
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function () {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 2) {
        $productThumbsWrapper.on(
          "init" + this.settings.namespace,
          this._productSwipeInit.bind(this),
        );

        var nextArrow;
        var prevArrow;
        var sliderArrows = window.sliderArrows || false;

        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
          nextArrow =
            '<button type="button" class="slick-next"><span class="medium-up--hide">' +
            sliderArrows.right +
            '</span><span class="small--hide">' +
            sliderArrows.down +
            "</span></button>";
          prevArrow =
            '<button type="button" class="slick-prev"><span class="medium-up--hide">' +
            sliderArrows.left +
            '</span><span class="small--hide">' +
            sliderArrows.up +
            "</span></button>";
        }

        // Thumbnail Progress Bar

        var $thumbProgressBar = $(".thumbprogress");

        $productThumbsWrapper.on("init", function (event, slick, currentSlide, nextSlide) {
          let thumbHundredPercentinit = Math.round(
            (slick.slideCount - slick.options.slidesToShow) / slick.options.slidesToScroll + 1,
          );
          let thumbCalcInit =
            (100 / thumbHundredPercentinit) *
            ((slick.currentSlide + slick.options.slidesToScroll) / slick.options.slidesToScroll);
          $thumbProgressBar.css("background-size", thumbCalcInit + "% 100%");
          if (slick.slideCount <= slick.options.slidesToShow) {
            $thumbProgressBar.css("display", "none");
          }
        });

        $productThumbsWrapper.on("breakpoint", function (event, slick, breakpoint) {
          if (slick.slideCount <= slick.options.slidesToShow) {
            $thumbProgressBar.css("display", "none");
          }
        });

        $productThumbsWrapper.on("afterChange", function (event, slick, currentSlide, nextSlide) {
          let thumbHundredPercent = Math.round(
            (slick.slideCount - slick.options.slidesToShow) / slick.options.slidesToScroll + 1,
          );
          let thumbCalc =
            (100 / thumbHundredPercent) *
            ((slick.currentSlide + slick.options.slidesToScroll) / slick.options.slidesToScroll);

          $thumbProgressBar.css("background-size", thumbCalc + "% 100%");
        });

        $productThumbsWrapper.slick({
          accessibility: false,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          vertical: true,
          verticalSwiping: true,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                vertical: false,
                verticalSwiping: false,
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 2,
                touchThreshold: 20,
              },
            },
          ],
        });

        // Show highlighted thumbnail by repositioning slider
        $productThumbsWrapper.slick(
          "slickGoTo",
          $productThumbsWrapper.find(".is-active").attr("data-slick-index"),
          true,
        );
      }
    },

    _productSwipeInit: function (evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on("swipeleft swiperight", function (event) {
        if (event.type === "swipeleft") {
          self._goToNextThumbnail();
        }

        if (event.type === "swiperight") {
          self._goToPrevThumbnail();
        }

        // Trigger click on newly requested thumbnail
        $(
          '.product-single__thumbnail-item[data-slick-index="' +
            self.settings.productThumbIndex +
            '"]',
        )
          .find(".product-single__thumbnail")
          .trigger("click");
      });
    },

    _goToNextThumbnail: function () {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        "slickGoTo",
        this.settings.productThumbIndex,
        true,
      );
    },

    _goToPrevThumbnail: function () {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        "slickGoTo",
        this.settings.productThumbIndex,
        true,
      );
    },

    _initQtySelector: function () {
      this.$container.find(".product-form__quantity").each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function () {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick("unslick");
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    },
  });

  return Product;
})();

theme.slideshows = {};

theme.Cart = (function () {
  var selectors = {
    cartNote: "#CartSpecialInstructions",
    cartQtyInput: ".cart__quantity",
    cartNoCookiesClass: "cart--no-cookies",
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    theme.cartObject = JSON.parse($("#CartJson-" + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function ($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function () {
      $(selectors.cartQtyInput).each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function () {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on("keyup input", function () {
        $(this)
          .css("height", "auto")
          .css("height", $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        "change",
        $.proxy(function () {
          noteText = $el.val();
          params = {
            type: "POST",
            url: "/cart/update.js",
            data: "note=" + this._attributeToString(noteText),
            dataType: "json",
          };
          $.ajax(params);
        }, this),
      );
    },

    _attributeToString: function (attr) {
      if (typeof attr !== "string") {
        attr = String(attr);
        if (attr === "undefined") {
          attr = "";
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

theme.Quotes = (function () {
  function Quotes(container) {
    this.$container = $(container).on("init", this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: false,
      dots: true,
      draggable: true,
      autoplay: false,
    });
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    },

    _goToSlide: function (slideIndex) {
      this.$container.slick("slickGoTo", slideIndex);
    },

    onUnload: function () {
      delete this.$container;
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(".quote__slide-wrapper--" + evt.detail.blockId + ":not(.slick-cloned)");
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    },
  });

  return Quotes;
})();

theme.Video = (function () {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function () {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement("script");

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function (defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function () {
            defer.reject("Request for YouTube API timed out after 30 seconds.");
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function (id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.YT === "undefined") {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly.",
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener("onReady", function () {
            defer.resolve(player);
          });

          setTimeout(function () {
            defer.reject("Request for YouTube player has timed out after 30 seconds.");
          }, 30000);
        });
      });
    },
  };

  var vimeo = {
    promiseAPI: function () {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function (defer) {
          var tag = document.createElement("script");
          tag.src = "https://player.vimeo.com/api/player.js";
          tag.onload = tag.onreadystatechange = function () {
            if (!this.readyState || this.readyState === "complete") {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function () {
            defer.reject("Request for Vimeo API timed out after 30 seconds.");
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function (id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.Vimeo === "undefined") {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly.",
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function () {
            defer.reject("Request for Vimeo player has timed out after 30 seconds.");
          }, 30000);

          player.ready().then(function () {
            defer.resolve(player);
          });
        });
      });
    },
  };

  var selectors = {
    loadPlayerButton: ".video-section__load-player-button",
    closePlayerButton: ".video-section__player-close",
    playerContainer: ".video-section__player",
    cover: ".video-section__cover",
    errorMessage: ".video-section__error",
    bodyOverlay: ".video-section__body-overlay",
    body: "body",
  };
  var classes = {
    playerLoading: "video-section--loading",
    playerLoaded: "video-section--loaded",
    playerError: "video-section--error",
    videoPlaying: "video-playing",
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr("data-section-id");
    this.namespace = "." + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function () {
      this.$container
        .on("click", selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on("click", selectors.closePlayerButton, this._closePlayer.bind(this))
        .on("click", selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function () {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr("data-video-type");

      var promiseVideoPlayer;

      if (playerType === "youtube") {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === "vimeo") {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function (container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr("data-video-id"),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0,
          },
        })
        .then(
          function (player) {
            this.player = player;
          }.bind(this),
        );
    },

    _loadVimeoPlayer: function (container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr("data-video-id"),
        })
        .then(
          function (player) {
            this.player = player;
            this.player.play();
          }.bind(this),
        );
    },

    _onPlayerLoadReady: function () {
      $(selectors.closePlayerButton, this.$container).show().focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this));
      $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this));
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace,
      });
    },

    _onPlayerLoadError: function (err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function (evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function () {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight < this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function () {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function () {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace,
      });

      if (typeof this.player.destroy === "function") {
        this.player.destroy();
      } else if (typeof this.player.unload === "function") {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    },
  });

  return Video;
})();

theme.CollectionsList = (function () {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is("[data-stretch-image]");

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = "." + $container.attr("data-section-id"));
    var self = this;

    self._collectionListFix();
    $(window).on(
      "resize" + namespace,
      $.debounce(250, function () {
        self._collectionListFix();
      }),
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function () {
      $(window).off(this.namespace);
    },

    _collectionListFix: function () {
      var numberRows = this.$container.find(".grid").data("number-rows");
      var $featureCards = this.$container.find(".featured-card");

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is("[data-stretch-image]")) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter("[data-row-number='" + (i + 1) + "']");
        var $cardHeaders = $currentRow.find(".featured-card__header");

        // Find the max heights for each row
        $currentRow.each(function () {
          var $cardTitle = $(this).find(".featured-card__title");
          var $cardAction = $(this).find(".featured-card__action");
          var $cardImageWrapper = $(this).find(".featured-card__image-wrapper");
          var headerHeight = $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    },
  });

  return CollectionsList;
})();

theme.ProductRecommendations = (function () {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data("baseUrl");
    var productId = this.$container.data("productId");
    var recommendationsSectionUrl =
      baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=6";

    $.get(recommendationsSectionUrl).then(
      function (section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== "") {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this),
    );
  }

  return ProductRecommendations;
})();

theme.init = function () {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function (evt) {
    evt.preventDefault();
  });

  // Sections
  var sections = new theme.Sections();
  sections.register("header", theme.HeaderSection);
  sections.register("product", theme.Product);
  sections.register("collection-filters", theme.Filters);
  sections.register("cart", theme.Cart);
  sections.register("quotes", theme.Quotes);
  sections.register("video", theme.Video);
  sections.register("collections-list", theme.CollectionsList);
  sections.register("product-recommendations", theme.ProductRecommendations);

  // Standalone modules
  $(window).on("load", theme.articleImages);
  theme.passwordModalInit();
  theme.productCardImageLoadingAnimation();
};

theme.articleImages = function () {
  var $indentedRteImages = $(".rte--indented-images");
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find("img").each(function (i, el) {
    var $el = $(el);
    var attr = $el.attr("style");

    // Check if undefined or float: none
    if (!attr || attr === "float: none;") {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent("p").addClass("rte__image-indent");
      }
    }
  });
};

theme.passwordModalInit = function () {
  var $loginModal = $("#LoginModal");
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals("LoginModal", "login-modal", {
    focusOnOpen: "#Password",
  });

  // Open modal if errors exist
  if ($loginModal.find(".errors").length) {
    theme.PasswordModal.open();
  }
};

theme.productCardImageLoadingAnimation = function () {
  var selectors = {
    image: "[data-image]",
    imagePlaceholder: "[data-image-placeholder]",
    imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]",
  };

  var classes = {
    hidden: "placeholder-background--hide",
  };

  $(document).on("lazyloaded", function (e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });
};

$(theme.init);

function resetAllCards(event) {
  var allCards = document.querySelectorAll(".product-card");

  allCards.forEach((card) => {
    if (!event.currentTarget.closest(".select-open")) {
      card.classList.remove("select-open");
      if (card.querySelector(".open-modal")) {
        card.querySelector(".open-modal").innerHTML = "Choose options";
      }
      if (card.querySelector(".product-card__image .luc-media")) {
        card.querySelector(".product-card__image .luc-media").style.paddingTop = "100%";
      }
      if (card.querySelector(".variants-wrapper")) {
        card.querySelector(".variants-wrapper").style.height = "0px";
      }
    }
  });
}

function openSelectModal(event) {
  var cardParent = event.target.closest(".product-card");
  var cardImages = cardParent.querySelectorAll(".product-card__image .luc-media");
  var cardButton = cardParent.querySelector(".open-modal");
  var modal = cardParent.querySelector(".variants-wrapper");
  var tag = cardParent.querySelector(".product-tag-wrapper");

  resetAllCards(event);

  cardImages.forEach((image) => {
    image.style.paddingTop = "calc(100% - " + modal.scrollHeight + "px)";
  });

  if (cardParent.querySelector(".open-modal").innerHTML === "Choose options") {
    cardParent.classList.add("select-open");
    cardButton.innerHTML = "Close";
    modal.style.height = modal.scrollHeight + "px";
    if (tag) {
      tag.classList.add("hidden");
    }

    if (window.innerWidth <= 768) {
      cardImages.forEach((image) => {
        image.style.paddingTop = "0px";
      });
    } else {
      cardImages.forEach((image) => {
        image.style.paddingTop = "calc(100% - " + modal.scrollHeight + "px)";
      });
    }
  } else {
    cardParent.classList.remove("select-open");
    cardButton.innerHTML = "Choose options";
    cardImages.forEach((image) => {
      image.style.paddingTop = "100%";
    });
    modal.style.height = "0px";
    if (tag) {
      tag.classList.remove("hidden");
    }
  }
}

function changeSelection(event) {
  var parent = event.target.closest(".variants-wrapper");
  var dropdowns = parent.querySelectorAll(".variant-dropdown");
  var variantString = "";
  dropdowns.forEach((dropdown) => {
    variantString += dropdown.value + " / ";
  });
  variantString = variantString.slice(0, -3);
  updateSelection(parent, variantString);
}
function updateSelection(parent, variant) {
  var allVariants = parent.querySelectorAll(".variant-option");
  var cardParent = parent.closest(".product-card");
  var cardImageImg = cardParent.querySelector("img");
  var cardPrice = cardParent.querySelector(".product-card__price");
  var variantButton = parent.querySelector("button.ctl-slide__btn");
  var variantAnchor = parent.querySelector("a.ctl-slide__btn");
  allVariants.forEach((option) => {
    if (variant == option.dataset.variant) {
      var available = option.dataset.available;
      var continueSell = option.dataset.continue;
      var isGiftCard = option.dataset.isGiftCard;
      var variantURL = option.dataset.url;
      option.removeAttribute("disabled");
      cardImageImg.setAttribute("src", option.dataset.image);
      cardImageImg.removeAttribute("srcset");
      cardPrice.innerHTML = option.dataset.price;
      if (available == "true") {
        if (continueSell == "true" && isGiftCard == "false") {
          variantAnchor.classList.remove("hide");
          variantAnchor.href = variantURL;
          variantButton.classList.add("hide");
        } else {
          variantAnchor.classList.add("hide");
          variantButton.classList.remove("hide");
          variantButton.querySelector(".cartbuttontext").innerHTML = "Add to Cart";
        }
        variantButton.classList.remove("variant-oos");
        variantButton.removeAttribute("disabled");
      } else {
        variantAnchor.classList.add("hide");
        variantButton.classList.remove("hide");
        variantButton.querySelector(".cartbuttontext").innerHTML = "Out Of Stock";
        variantButton.classList.add("variant-oos");
        variantButton.setAttribute("disabled", "disabled");
      }
    } else {
      option.setAttribute("disabled", "disabled");
    }
  });
}

function globalAddItemFromForm(evt) {
  evt.preventDefault();
  const form = $(evt.target).closest("form");
  let buttonClicked = evt.target.querySelector("#AddToCart-product-card");
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: form.serialize(),
    dataType: "json",
    success: $.proxy(function (lineItem) {
      globalSuccess(lineItem, buttonClicked);
    }),
    error: $.proxy(function (XMLHttpRequest, textStatus) {
      globalError(XMLHttpRequest);
    }),
  };

  $.ajax(params);
}

function globalSuccess(lineItem, buttonClicked) {
  const event = new CustomEvent("cart:update");
  document.querySelector("main-cart")?.dispatchEvent(event);

  if (!window.location.pathname.includes("/cart")) {
    theme.Notify.open("success", false, true);
  }

  // Update cart notification bubble's state
  var currentValue = $(".site-header__cart-indicator").text();
  var newValue = +currentValue + 1;
  $(".site-header__cart-indicator").text(newValue);
  $(".site-header__cart-indicator").removeClass("hide");

  // var $el = document.querySelectorAll("#AddToCart-product-card").forEach(button => button.classList.add('active'));
  if (!buttonClicked) return;
  buttonClicked.classList.add("active");

  setTimeout(function () {
    buttonClicked.classList.remove("active");
  }, 2000);
}

function globalError(XMLHttpRequest) {
  var data = JSON.parse(XMLHttpRequest.responseText);

  if (data.message) {
    theme.Notify.open("error", data.description, true);
  }
}

const productCardForms = document.querySelectorAll(".product-card form");
productCardForms.forEach((form) => {
  form.addEventListener("submit", globalAddItemFromForm);
});

class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.section_wrapper = this.closest("header");
    this.outer_wrapper = this.closest(".site-header__outer");
    this.padding =
      parseInt(window.getComputedStyle(this).getPropertyValue("padding-left").replace("px", "")) *
      2;

    this.nav_track = this.querySelector(".main-navigation__inner");
    this.nav_items = this.querySelectorAll(".main-navigation__parent-item");

    this.min_track_width = 0;
    this.nav_items.forEach((item) => {
      const width = item.getBoundingClientRect().width;
      this.min_track_width = this.min_track_width + width;
    });
  }

  connectedCallback() {
    this.addEventListeners();
    this.collapseNavigation();

    theme.Notify = new window.Notify();
  }

  addEventListeners() {
    window.addEventListener("scroll", this.stickyNavigation.bind(this));
    window.addEventListener("resize", this.collapseNavigation.bind(this));
    window.addEventListener("DOMContentLoaded", this.collapseNavigation.bind(this));
  }

  stickyNavigation() {
    const wrapper = this.section_wrapper.getBoundingClientRect();
    if (window.scrollY > wrapper.top) {
      this.outer_wrapper.classList.add("site-header__sticky");
    } else {
      this.outer_wrapper.classList.remove("site-header__sticky");
    }
  }

  collapseNavigation() {
    this.track_width = this.nav_track.getBoundingClientRect().width;
    if (window.outerWidth <= this.collapse_point || this.track_width <= this.min_track_width) {
      if (!this.collapse_point) {
        this.collapse_point = window.outerWidth;
      }
      this.outer_wrapper.classList.add("site-header__collapse");
    } else {
      this.outer_wrapper.classList.remove("site-header__collapse");
    }
  }
}

customElements.define("site-header", SiteHeader);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
    this.is_touch = true; // Manual set for clicks
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.is_touch) {
      this.addEventListener("click", this.clickHandler.bind(this));
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    } else {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest('[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("dropdown-menu") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseenter") {
      this.setVisible();
    } else if (e.type === "mouseleave") {
      this.toggle_button.blur();
      this.setHidden();
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      this.toggleMenu();
    }
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (this.getAttribute("dropdown-view") === "hidden") {
      this.setVisible();
    } else if (this.getAttribute("dropdown-view") === "visible") {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.setAttribute("dropdown-view", "hidden");
    this.toggle_button.setAttribute("aria-expanded", "false");
  }

  setVisible() {
    this.is_open = true;
    this.setAttribute("dropdown-view", "visible");
    this.toggle_button.setAttribute("aria-expanded", "true");
  }
}

customElements.define("dropdown-menu", DropdownMenu);

class DrawerNavigation extends DropdownMenu {
  constructor() {
    super();

    this.menu_parents = this.querySelectorAll(".drawer-navigation__parent-item");
    this.menu_children = this.querySelectorAll(".drawer-navigation__child-item");
    this.header_group = document.querySelectorAll(
      ".shopify-section-group-header-group:not(.usp-banner)",
    );
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));
    if (!this.is_touch) {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    // if (e.target.closest(".drawer-navigation__button")) {
    //   const btn = e.target.closest(".drawer-navigation__button");
    //   this.scrollToTop(btn);
    // }
    if (e.target.closest('.menu__button[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
    if (
      e.target.getAttribute("aria-expanded") ||
      e.target.parentElement.getAttribute("aria-expanded")
    ) {
      e.preventDefault();
      e.target.getAttribute("aria-expanded")
        ? e.target.getAttribute("aria-expanded") === "true"
          ? e.target.setAttribute("aria-expanded", "false")
          : e.target.setAttribute("aria-expanded", "true")
        : e.target.parentElement.getAttribute("aria-expanded") === "true"
          ? e.target.parentElement.setAttribute("aria-expanded", "false")
          : e.target.parentElement.setAttribute("aria-expanded", "true");
    }
  }

  scrollToTop(btn) {
    btn.closest("#drawer-menu").scrollTop = 0;
  }

  outsideClickHandler(e) {
    if (e.target.closest("drawer-navigation") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
        this.closeAllMenus();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded")) {
        e.preventDefault();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.closeAllMenus();
    }
  }

  toggleMenu() {
    super.toggleMenu();
    if (this.getAttribute("dropdown-view") === "visible") {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    this.menu_parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
    this.menu_children.forEach((child) => {
      child.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("drawer-navigation", DrawerNavigation);

class MainNavigation extends HTMLElement {
  constructor() {
    super();

    this.parents = this.querySelectorAll(".main-navigation__parent-item");
    this.menu_links = this.querySelectorAll(".main-navigation__parent-menu a[data-image]");
    this.is_touch = true;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.parents.forEach((parent) => {
      if (this.is_touch) {
        parent.addEventListener("click", this.clickHandler.bind(this));
      } else {
        parent.addEventListener("mouseenter", this.mouseHandler.bind(this));
        parent.addEventListener("mouseleave", this.mouseHandler.bind(this));
      }
    });
    this.menu_links.forEach((link) => {
      if (!this.is_touch) {
        link.addEventListener("mouseenter", this.previewHandler.bind(this));
      }
    });

    if (this.is_touch) {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.classList.contains("main-navigation__parent-button") &&
      e.target.getAttribute("aria-expanded") === "false"
    ) {
      e.preventDefault();
      this.closeAllMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("main-navigation") !== this) {
      this.closeAllMenus();
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseleave") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    } else if (e.type === "mouseenter") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true");
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded") === "false") {
        e.preventDefault();
        this.closeAllMenus();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.parents.forEach((parent) => {
        parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      });
    }
  }

  previewHandler(e) {
    const image_url = e.target.dataset.image;
    const preview_container = e.target
      .closest(".main-navigation__parent-menu")
      .querySelector(".previews-active");
    if (!image_url || !preview_container) return;
    let preview_image = preview_container.querySelector("img");
    if (!preview_image) {
      preview_image = document.createElement("img");
      preview_image.setAttribute("loading", "lazy");
      preview_image.classList.add("luc-img__asset");
      preview_container.querySelector(".luc-img").appendChild(preview_image);
    }
    preview_image.src = image_url;
  }

  closeAllMenus() {
    this.parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("main-navigation", MainNavigation);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
      type: this.getAttribute("search-type") || "product,query,collection,page",
      limit: this.getAttribute("search-scope") || "10",
      scope: this.getAttribute("search-scope") || "each",
      fields:
        this.getAttribute("search-fields") || "title,product_type,body,variants.title,variants.sku",
      unavailable: this.getAttribute("search-unavailable") || "last",
    };
    this.appearance = {
      type: this.getAttribute("appearance-type") || "bar",
    };
    this.predictiveSearchResults = this.querySelector("#predictive-search-results");
    this.inputWrapper = this.querySelector(".input-wrapper");
    this.closeBtn = this.querySelector(".close-results");
    this.closeBtnBottom = this.querySelector(".close-results-bottom");
    this.resultsOverlay = document.querySelector(".predictive-search-overlay");
    this.mobileNav = document.querySelector(".drawer");
    this.mobileBurgerBtn = document.querySelector("button.js-drawer-open-left");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
    this.setAttribute("search-loaded", "true");
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.inputChange(event);
      }, 300).bind(this),
    );

    this.clear = this.querySelector(".input-clear");
    document.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (e.target === this.closeBtn || e.target.closest(".close-results")) {
      this.closeResultsPane();
      this.toggleSearch("close");
      return;
    }
    if (e.target === this.closeBtnBottom || e.target.closest(".close-results-bottom")) {
      this.closeResultsPane();
      return;
    }
    if (e.target === this.resultsOverlay || e.target.closest(".predictive-search-overlay")) {
      this.unsetActive();
      this.closeResultsPane();
      this.toggleSearch("close");
      return;
    }
    if (e.target === this.searchIcon || e.target.closest(".search-button")) {
      this.toggleSearch();
      return;
    }
    if (!e.target.closest("predictive-search")) {
      if (!e.target === this.mobileNav || !e.target.closest(".drawer")) {
        if (this.searchIcon) {
          this.toggleSearch("close");
        } else {
          this.unsetActive();
        }
        return;
      }
    }
  }

  attributeChangedCallback(name, prev, next) {
    // triggers whenever the search-query param is set, handle everything here
    if (next === "") {
      // input field is empty, clear DOM and close results pane
      this.closeResultsPane();
      this.predictiveSearchResults.innerHTML = "";
      return;
    }
    if (prev === next && this.DOMCache) {
      return;
    }

    // new query
    this.getNewSearch();
  }

  static get observedAttributes() {
    return ["search-query"];
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  async getNewSearch() {
    this.loadingElem = this.querySelector(".predictive-search__loading");
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
    let string = `/search/suggest?q=${this.search.query}&resources[type]=${this.search.type}&resources[limit]=${this.search.limit}&resources[limit_scope]=${this.search.scope}&resources[options][fields]=${this.search.fields}&resources[options][unavailable_products]=${this.search.unavailable}&section_id=predictive-search`;
    try {
      const response = await fetch(string);
      if (!response.ok) {
        const error = new Error(response.status);
        throw error;
      }
      const data = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector("#shopify-section-predictive-search").innerHTML;
      this.DOMCache = resultsMarkup;
      this.predictiveSearchResults.innerHTML = this.DOMCache;
      this.openResultsPane();
    } catch (error) {
      this.closeResultsPane();
    }
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
  }

  handleFocus() {
    const dummyInput = document.createElement("input");
    dummyInput.setAttribute("type", "text");
    const styleObject = { position: "absolute", opacity: "0", height: "0", fontSize: "16px" };
    Object.assign(dummyInput.style, styleObject);

    this.prepend(dummyInput);
    dummyInput.focus();

    setTimeout(() => {
      this.input.focus();
      dummyInput.remove();
    }, 500);
  }

  positionResultsPane() {
    this.predictiveSearchResults.removeAttribute("style");
    const results = this.predictiveSearchResults.getBoundingClientRect();
    if (this.predictiveSearchResults.scrollHeight + results.top + 20 > window.innerHeight) {
      this.predictiveSearchResults.style.height = window.innerHeight - 20 - results.top + "px"; // remove an extra 20px from height to space from bottom of browser window
    }
  }

  openResultsPane() {
    this.positionResultsPane();
    if (this.predictiveSearchResults.innerHTML !== "") {
      this.predictiveSearchResults.classList.add("predictive-search-results--visible");
    }
    this.resultsOverlay?.classList.remove("hidden");
    this.querySelector("form").style.border = "2px solid #f58020";
  }

  closeResultsPane() {
    this.predictiveSearchResults.classList.remove("predictive-search-results--visible");
    this.resultsOverlay?.classList.add("hidden");
    this.querySelector("form").style.border = "2px solid transparent";
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  toggleSearch(force) {
    if (this.searchIcon) {
      const isActive = this.searchIcon.getAttribute("aria-expanded") === "true" ? true : false;
      this.searchIcon.setAttribute("aria-expanded", !isActive);
      if (force === "close") {
        this.unsetActive();
        this.searchIcon.setAttribute("aria-expanded", "false");
      } else if (isActive) {
        this.unsetActive();
      } else {
        this.setActive();
        this.input.focus();
        this.handleFocus();
      }
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
    this.openResultsPane();
  }

  unsetActive() {
    this.inputWrapper.classList.remove("input-wrapper--active");
    this.closeResultsPane();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
    if (this.appearance.type == "icon") {
      const iconButton = document.createElement("button");
      const style = document.createElement("style");

      style.textContent = `
        .search-toggle {transition: none;}
        .search-button{-webkit-appearance:none;appearance:none;width:30px;height:30px;border:0;padding:0;background:none;display:flex;align-items:center;}
        .search-button + form{display:none}
        .search-button[aria-expanded="true"] + form{display:block}
        predictive-search form{top:0;min-width:300px;background:#fff;right:36px;}
        predictive-search[appearance-type="bar"] form{position:relative;top:0;min-width:100%;background:#fff;right:0;}
        .site-header__collapse predictive-search[appearance-type="bar"] form{position:static}
        @media (max-width: 1024px) {
          predictive-search[appearance-type="bar"] form{position:static}
        }
        .search-toggle{width: 100%}
        @media screen and (min-width: 769px) {
          predictive-search .mphus-icon:not(.search-toggle) {height:30px;width: auto}
        }

        @media screen and (max-width:1225px) {
          .search-button + form{display:block;opacity:0;visibility:hidden;pointer-events:none;transition:all .2s ease;width: calc(100% - 40px);margin: 0 auto}
          .search-button[aria-expanded="true"] + form{opacity:1;visibility:visible;pointer-events:all;transform: translateY(40px);}
          predictive-search form{top:50%;right:0;width:calc(100% - 50px);left:0;z-index:1;}

        }
        @media screen and (max-width:768px) {
          predictive-search form{position:absolute!important;}
          .search-button[aria-expanded="true"] + form{transform: translateY(60px);}
        }
      `;
      iconButton.classList.add("search-button");
      iconButton.setAttribute("aria-expanded", "false");
      iconButton.innerHTML = `
        <img src="//heat-holders-uk.myshopify.com/cdn/shop/files/search_x80.png?v=1786019200" srcset="//heat-holders-uk.myshopify.com/cdn/shop/files/search_x80.png?v=1786019200 1x, //heat-holders-uk.myshopify.com/cdn/shop/files/search_x80@2x.png?v=1786019200 2x" alt="Search" class="mphus-icon search-toggle">
      `;
      this.appendChild(style);
      this.insertBefore(iconButton, this.firstElementChild);
      this.searchIcon = iconButton;
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);

class StaticSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
    };
    this.inputWrapper = this.querySelector(".input-wrapper");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener("input", (event) => {
      this.inputChange(event);
    });
    this.querySelector("form").addEventListener("submit", this.triggerResultsRefresh.bind(this));

    document.addEventListener("click", this.clickHandler.bind(this));
    this.clear = this.querySelector(".input-clear");
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (!e.target.closest("static-search")) {
      this.unsetActive();
      return;
    }
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  triggerResultsRefresh(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const searchParams = new URLSearchParams(formData).toString();
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParams,
        type: "q",
      },
    });
    document.dispatchEvent(event);
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
  }
}

customElements.define("static-search", StaticSearch);

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.mouseDown = false;
    this.startX = 0;
    this.handle = null;
    this.minHandle = null;
    this.maxHandle = null;
  }

  addEventListeners() {
    this.addEventListener("mousemove", this.dragHandler.bind(this));
    this.addEventListener("touchmove", this.dragHandler.bind(this));

    this.addEventListener("mousedown", this.startHandler.bind(this));
    this.addEventListener("touchstart", this.startHandler.bind(this));

    this.addEventListener("mouseup", this.endHandler.bind(this));
    this.addEventListener("touchend", this.endHandler.bind(this));
    this.addEventListener("mouseleave", this.endHandler.bind(this));

    document.addEventListener("range:set", this.setHandlePositions.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("mousemove", this.dragHandler.bind(this));
    this.removeEventListener("touchmove", this.dragHandler.bind(this));

    this.removeEventListener("mousedown", this.startHandler.bind(this));
    this.removeEventListener("touchstart", this.startHandler.bind(this));

    this.removeEventListener("mouseup", this.endHandler.bind(this));
    this.removeEventListener("touchend", this.endHandler.bind(this));
    this.removeEventListener("mouseleave", this.endHandler.bind(this));

    document.removeEventListener("range:set", this.setHandlePositions.bind(this));
  }

  connectedCallback() {
    this.minHandle = this.querySelector("#range-slider-min");
    this.maxHandle = this.querySelector("#range-slider-max");
    this.handleWidth = this.minHandle.offsetWidth;
    this.trackSize = this.offsetWidth - this.handleWidth;
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  dragHandler(e) {
    if (!this.mouseDown) return;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    const x =
      pageX -
      (this.getBoundingClientRect().left + e.currentTarget.offsetLeft - this.handleWidth / 2);
    let percentage = 0;
    if (this.handle.id === "range-slider-min" && x < this.handleWidth / 2) {
      this.handle.style.left = `${this.handleWidth / 2}px`;
      percentage = 0;
    } else if (
      this.handle.id === "range-slider-max" &&
      x > this.offsetWidth - this.handleWidth / 2
    ) {
      this.handle.style.left = `${this.offsetWidth - this.handleWidth / 2}px`;
      percentage = 100;
    } else {
      if (
        this.handle.id === "range-slider-min" &&
        x >= this.maxHandle.offsetLeft - this.handleWidth / 2
      ) {
        this.handle.style.left = `${this.maxHandle.offsetLeft - this.handleWidth / 2}px`;
      } else if (
        this.handle.id === "range-slider-max" &&
        x <= this.minHandle.offsetLeft + this.handleWidth * 1.5
      ) {
        this.handle.style.left = `${this.minHandle.offsetLeft + this.handleWidth * 1.5}px`;
      } else {
        this.handle.style.left = `${x}px`;
      }
      percentage = (this.handle.offsetLeft / this.trackSize) * 100;
    }

    // event to update the min and max values as percentages
    this.sendUpdatedHandleValue(this.handle.id, percentage);
  }

  startHandler(e) {
    if (!e.target.classList.contains("range-slider__handle")) return;

    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    this.mouseDown = true;
    this.startX =
      pageX -
      (this.getBoundingClientRect().left + e.currentTarget.offsetLeft - this.handleWidth / 2);
    this.handle = e.target;
  }

  endHandler(e) {
    if (this.mouseDown) {
      const event = new CustomEvent("range:complete");
      document.dispatchEvent(event);
    }
    this.mouseDown = false;
  }

  setHandlePositions(e) {
    const {
      detail: { min, max },
    } = e;

    const maxPosition = (max.current / max.limit) * 100;
    const minPosition = (min.current / max.limit) * 100;

    this.maxHandle.style.left = `${(this.trackSize / 100) * maxPosition + this.handleWidth / 2}px`;
    this.minHandle.style.left = `${(this.trackSize / 100) * minPosition + this.handleWidth / 2}px`;
  }

  sendUpdatedHandleValue(id, percentage) {
    const event = new CustomEvent("range:update", {
      detail: {
        id,
        percentage,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("range-slider", RangeSlider);

class ResultsGrid extends HTMLElement {
  constructor() {
    super();

    this.showCount = this.getAttribute("count-active") === "true" ? true : false;
    this.showSorting = this.getAttribute("sorting-active") === "true" ? true : false;
    this.showFilters = this.getAttribute("filters-active") === "true" ? true : false;
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("results:refresh:start", this.changeHandler.bind(this));
    window.addEventListener("popstate", () => {
      window.location.reload();
    });
    document.addEventListener("DOMContentLoaded", () => {
      const topBar = document.querySelector(".announcement-bar");
      const header = document.querySelector(".site-header");
      this.headerHeight = header?.offsetHeight; // + topBar?.offsetHeight;
    });
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("results:refresh:start", this.changeHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".main-pagination__wrapper")) {
      this.paginationClick(e);
      return;
    }
    if (e.target.dataset.clear && e.target.closest(".results-grid__empty")) {
      const event = new CustomEvent("filters:clear", {
        detail: {
          changeFilter: e.target,
        },
      });
      document.dispatchEvent(event);
    }
  }

  changeHandler(e) {
    this.createSearchString(e);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  paginationClick(e) {
    e.preventDefault();
    const url = e.target.href;
    if (!url) return;
    const paginationUrl = new URL(e.target.href);
    const filteredParams = Array.from(paginationUrl.searchParams.entries()).filter((param) => {
      return param[0].indexOf("page") === 0;
    });
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: new URLSearchParams(filteredParams),
        type: "page",
      },
    });
    document.dispatchEvent(event);
  }

  createSearchString(e) {
    const type = e.detail.type;
    const currentSearchParams = Array.from(new URLSearchParams(window.location.search).entries());
    const newSearchParams = new URLSearchParams(e.detail.params);
    const filteredParams = currentSearchParams.filter((param) => {
      if (type !== "page") {
        return param[0].indexOf(type) === -1 && param[0].indexOf("page") === -1;
      } else {
        return param[0].indexOf(type) === -1;
      }
    });
    const searchString = new URLSearchParams([...filteredParams, ...newSearchParams]).toString();
    this.refreshResults(`${window.location.pathname}?${searchString}`);
  }

  updateHistory(url) {
    const currentUrl = new URL(`${window.location.origin}${url}`);
    history.pushState(null, null, currentUrl);
  }

  async refreshResults(url) {
    this.classList.add("results-grid--loading");
    let thisTop = this.offsetTop - this.headerHeight;
    if (window.scrollY > thisTop) {
      window.scrollTo({
        top: thisTop,
        behavior: "smooth",
      });
    }
    try {
      const response = await fetch(`${url}`);
      const data = await response.text();
      const dataHtml = document.createElement("div");
      dataHtml.innerHTML = data;

      const products = dataHtml.querySelector(".results-grid__products");
      const pagination = dataHtml.querySelector(".results-grid__pagination");

      const productElement = this.querySelector(".results-grid__products");
      const paginationElement = this.querySelector(".results-grid__pagination");

      productElement.innerHTML = products.innerHTML;
      paginationElement.innerHTML = pagination.innerHTML;

      if (this.showCount) {
        const productsCount = dataHtml.querySelector(".results-grid__count");
        const productsCountElement = this.querySelector(".results-grid__count");
        productsCountElement.innerHTML = productsCount.innerHTML;
      }
      if (this.showFilters) {
        const dataFiltersElem = dataHtml.querySelector(".results-grid__filters");
        const currentFiltersElem = this.querySelector(".results-grid__filters");

        if (
          !dataFiltersElem.classList.contains("results-grid__filters--hide") &&
          currentFiltersElem.classList.contains("results-grid__filters--hide")
        ) {
          // if refreshed doesnt have hide class and current page has hide, indicates a matching search so insert filters
          currentFiltersElem.innerHTML = dataFiltersElem.innerHTML;
          currentFiltersElem.classList.remove("results-grid__filters--hide");
        }
        if (!currentFiltersElem.classList.contains("results-grid__filters--hide")) {
          const filters = dataHtml.querySelector(
            ".results-grid__filters .results-filters__form .form__content",
          ).outerHTML;
          const mobileButtonCount = dataHtml.querySelector(".results-filters__footer-buttons");
          const mobileButtonCountElement = this.querySelector(".results-filters__footer-buttons");
          productElement.classList.remove("results-grid__products--full");
          mobileButtonCountElement.innerHTML = mobileButtonCount.innerHTML;

          const event = new CustomEvent("results:refresh:success", {
            detail: {
              filter_data: filters,
            },
          });
          document.dispatchEvent(event);
        }
      }

      this.updateHistory(url);
    } catch (error) {
      console.log(error);
    } finally {
      this.classList.remove("results-grid--loading");
    }
  }
}

customElements.define("results-grid", ResultsGrid);

class ResultsFilters extends HTMLElement {
  constructor() {
    super();
    this.orientation =
      this.closest("results-grid").getAttribute("filter-orientation") || "vertical";
  }

  connectedCallback() {
    this.addEventListeners();
    this.windowWidth = 0;
    this.detectDevice();

    if (!this.querySelector(".price__range")) return;

    this.minPriceElem = this.querySelector('.price__range-from input[type="number"]');
    this.maxPriceElem = this.querySelector('.price__range-to input[type="number"]');
    this.minPrice = parseInt(this.minPriceElem.getAttribute("min"));
    this.maxPrice = parseInt(this.maxPriceElem.getAttribute("max"));

    this.setRangeHandles();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  detectDevice() {
    if (window.innerWidth !== this.windowWidth) {
      if (window.innerWidth <= 768) {
        this.setAttribute("aria-expanded", "false");
        this.resetDrawerState();
      } else {
        this.setAttribute("aria-expanded", "true");
      }
      this.windowWidth = window.innerWidth;
    }
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    if (this.orientation === "horizontal") {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }
    window.addEventListener("resize", this.detectDevice.bind(this));
    document.addEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.addEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.addEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.addEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.addEventListener('input', this.inputHandler.bind(this));
    // document.addEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    window.removeEventListener("resize", this.detectDevice.bind(this));
    document.removeEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.removeEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.removeEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.removeEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.removeEventListener('input', this.inputHandler.bind(this));
    // document.removeEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  clickHandler(e) {
    if (e.detail?.changeFilter || e.target.dataset.filter || e.target.dataset.clear) {
      const target = e.detail.changeFilter ? e.detail.changeFilter : e.target;
      if (target.dataset.active) {
        e.preventDefault();
        // uncheck if active filter is clicked
        if (target.dataset.filter !== "price") {
          this.querySelector(
            `[type="checkbox"][data-filter="${target.dataset.filter}"][value="${target.dataset.value}"]`,
          ).checked = false;
        } else {
          this.querySelectorAll(`[type="number"]`).forEach((filter) => {
            filter.value = "";
            filter.setAttribute("name", "");
          });
        }
      }
      if (target.dataset.clear) {
        e.preventDefault();
        this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
          filter.checked = false;
        });
        this.querySelectorAll(`[type="number"]`).forEach((filter) => {
          filter.value = "";
          filter.setAttribute("name", "");
        });
      }
      this.checkPriceFilters();
      this.debounce(() => this.changeFilter());
      return;
    }
    if (e.target.closest(".btn-elem--price")) {
      e.preventDefault();
      this.applyPriceRange();
    }
    if (e.target.classList.contains("filter__header") || e.target.closest(".filter-option__back")) {
      if (this.orientation === "horizontal") {
        if (e.target.closest(".filter") != this.current_open_filter) {
          this.querySelectorAll(".filter__header").forEach((header) => {
            header.setAttribute("aria-expanded", "false");
          });
        }
      }
      // toggle filter list dropdown
      const target = e.target.closest(".filter").querySelector(".filter__header");
      const toggle = target.ariaExpanded === "true" ? true : false;
      this.current_open_filter = target.closest(".filter");
      target.ariaExpanded = !toggle;
      return;
    }
    if (e.target.classList.contains("filter__more")) {
      e.preventDefault();
      const toggle = e.target.ariaExpanded === "true" ? true : false;
      e.target.ariaExpanded = !toggle;
      e.target.textContent === theme.strings.show_more
        ? (e.target.textContent = theme.strings.show_less)
        : (e.target.textContent = theme.strings.show_more);
      return;
    }
    if (e.target.dataset.action === "open-filter-drawer") {
      this.openFilterDrawer();
      return;
    }
    if (e.target.dataset.action === "close-filter-drawer") {
      this.closeFilterDrawer();
      return;
    }
  }

  outsideClickHandler(e) {
    if (window.innerWidth > 767) {
      if (!e.target.closest(".filter")) {
        this.resetDrawerState();
      }
    }
  }

  inputHandler(e) {
    if (!e.target.dataset.priceFilter) return;
    this.debounce(() => {
      this.applyPriceRange();
    }, 1000);
  }

  eventHandler(e) {
    const fragment = document.createElement("div");
    fragment.innerHTML = e.detail.filter_data;
    const filters = fragment.querySelectorAll("[data-filter]");
    filters.forEach((filter) => {
      const element = this.querySelector(
        `[data-filter="${filter.dataset.filter}"][value="${filter.value}"]`,
      );
      const parent = element.parentElement;
      element.dataset.count = filter.dataset.count;
      filter.dataset.count <= 0
        ? parent.classList.add("filter-option--nocount")
        : parent.classList.remove("filter-option--nocount");
      filter.dataset.count <= 0
        ? parent.classList.remove("filter-option--hascount")
        : parent.classList.add("filter-option--hascount");
      element.nextElementSibling.querySelector(".filter-option__count").textContent =
        `(${filter.dataset.count})`;
    });
  }

  openFilterDrawer() {
    this.setAttribute("aria-expanded", "true");
  }

  closeFilterDrawer() {
    this.setAttribute("aria-expanded", "false");
    this.debounce(() => {
      this.resetDrawerState();
    });
  }

  checkPriceFilters(e) {
    this.minPriceElem.value === "" ? (this.minPriceElem.value = this.minPrice) : null;
    this.maxPriceElem.value === "" ? (this.maxPriceElem.value = this.maxPrice) : null;

    const minElemValue = parseInt(this.minPriceElem.value);
    const maxElemValue = parseInt(this.maxPriceElem.value);

    minElemValue < this.minPrice ? (this.minPriceElem.value = this.minPrice) : null;
    minElemValue > this.maxPrice ? (this.minPriceElem.value = this.maxPrice) : null;
    maxElemValue < this.minPrice ? (this.maxPriceElem.value = this.minPrice) : null;
    maxElemValue > this.maxPrice ? (this.maxPriceElem.value = this.maxPrice) : null;

    minElemValue > maxElemValue ? (this.maxPriceElem.value = this.minPriceElem.value) : null;

    if (minElemValue === this.minPrice && maxElemValue === this.maxPrice) {
      this.minPriceElem.setAttribute("name", "");
      this.maxPriceElem.setAttribute("name", "");
    } else {
      this.minPriceElem.setAttribute("name", this.minPriceElem.dataset.priceFilter);
      this.maxPriceElem.setAttribute("name", this.maxPriceElem.dataset.priceFilter);
    }
    this.setRangeHandles();
  }

  setRangeHandles() {
    const event = new CustomEvent("range:set", {
      detail: {
        min: {
          current:
            this.minPriceElem.value !== "" ? parseInt(this.minPriceElem.value) : this.minPrice,
          limit: this.minPrice,
        },
        max: {
          current:
            this.maxPriceElem.value !== "" ? parseInt(this.maxPriceElem.value) : this.maxPrice,
          limit: this.maxPrice,
        },
      },
    });
    document.dispatchEvent(event);
  }

  updatePriceRange(e) {
    const { id, percentage } = e.detail;
    if (!this.querySelector(".filter-option--price")) return;

    const filter = this.querySelector(
      id === "range-slider-min"
        ? '.price__range-from input[type="number"]'
        : '.price__range-to input[type="number"]',
    );
    const maxValue = filter.getAttribute("max");

    filter.value = Math.round((percentage / 100) * maxValue);
  }

  applyPriceRange() {
    this.checkPriceFilters();
    this.changeFilter();
  }

  changeFilter() {
    const filtersForm = new FormData(this.querySelector("form"));
    const searchParamsArr = [];
    for (const [key, value] of filtersForm) {
      if (key.indexOf("filter") !== -1) {
        searchParamsArr.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    const searchParamsStr = searchParamsArr.join("&");
    // emit custom event with search string as payload
    const filterChangeEvent = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParamsStr,
        type: "filter",
      },
    });
    document.dispatchEvent(filterChangeEvent);
    this.updateActiveFilters(filtersForm);
  }

  createActiveFilterButton(filter) {
    const button = document.createElement("button");
    let attributes = {};
    let label = "";
    if (typeof filter[0] === "object") {
      // is price filter
      attributes = {
        "data-filter": "price",
        "data-active": "true",
        "aria-label": "Remove filter: Price range",
      };
      for (const priceGroup of filter) {
        if (priceGroup[0].indexOf("gte") !== -1) {
          attributes["data-filter-from"] = priceGroup[0];
          attributes["data-value-from"] = priceGroup[1];
        } else if (priceGroup[0].indexOf("lte") !== -1) {
          attributes["data-filter-to"] = priceGroup[0];
          attributes["data-value-to"] = priceGroup[1];
        }
      }
      label = `Price: ${theme.Currency.formatMoney(
        attributes["data-value-from"] * 100,
        theme.moneyFormatNoDecimals,
      )} - ${theme.Currency.formatMoney(
        attributes["data-value-to"] * 100,
        theme.moneyFormatNoDecimals,
      )}`;
    } else {
      // is normal filter
      attributes = {
        "data-filter": filter[0],
        "data-value": filter[1],
        "data-active": "true",
        "aria-label": `Remove filter: ${decodeURIComponent(filter[1].replace(/\+/g, " "))}`,
      };
      label = decodeURIComponent(filter[1].replace(/\+/g, " "));
    }
    for (const key in attributes) {
      button.setAttribute(key, attributes[key]);
    }
    button.classList.add("active-filters__button");
    button.innerHTML = `${label}<span class="active-filters__cross" aria-hidden="true"></span>`;
    return button;
  }

  updateActiveFilters(filters = []) {
    const filter_count = this.querySelector("span.active__count");
    const buttons = document.createDocumentFragment();
    let count = 0;
    let priceFilter = [];
    for (const filter of filters) {
      if (filter[0].indexOf("filter") !== -1) {
        if (filter[0].indexOf("filter.v.price") !== -1) {
          filter[1] !== "" ? priceFilter.push(filter) : null;
        } else {
          count++;
          const button = this.createActiveFilterButton(filter);
          buttons.appendChild(button);
        }
      }
    }
    if (priceFilter.length !== 0) {
      count++;
      const button = this.createActiveFilterButton(priceFilter);
      buttons.appendChild(button);
    }
    if (count > 0) {
      const clearButton = document.createElement("button");
      clearButton.classList.add("active-filters__clear");
      clearButton.setAttribute("data-clear", "true");
      clearButton.textContent = "Clear all";
      buttons.appendChild(clearButton);
      filter_count.innerHTML = `(${count})`;
    } else {
      this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
        filter.checked = false;
      });
      this.querySelectorAll(`[type="number"]`).forEach((filter) => {
        filter.value = null;
      });
      filter_count.innerHTML = "";
    }
    const activeFilters = this.querySelector(".active-filters");
    activeFilters.replaceChildren(buttons);
    this.querySelectorAll(".active-filters").forEach((container, index) => {
      if (index !== 0) {
        container.innerHTML = activeFilters.innerHTML;
      }
    });
  }

  resetDrawerState() {
    this.querySelectorAll(".filter__header").forEach((header) => {
      header.setAttribute("aria-expanded", "false");
    });
  }

  debounce(fn, wait = 300) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("results-filters", ResultsFilters);

class ResultsSorting extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("input", this.changeHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("input", this.changeHandler.bind(this));
  }

  changeHandler(e) {
    this.querySelector("label").dataset.activeSort = e.target.querySelector(
      `option[value="${e.target.value}"]`,
    ).innerHTML;
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: `sort_by=${e.target.value}`,
        type: "sort_by",
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("results-sorting", ResultsSorting);

class CombinedCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".combined-cart__content");
    this.productIds = [...this.querySelectorAll(".combined-cart__product")].map((container) => {
      return container.id.split("-")[1];
    });
    this.selectedProducts = {};
    this.submitter = this.querySelector('.btn-elem[type="submit"]');
  }

  connectedCallback() {
    this.addEventListeners();
    this.productIds.forEach((id) => {
      this.updateVariant(id);
    });
  }

  addEventListeners() {
    this.form.addEventListener("input", this.handleInput.bind(this));
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleInput(e) {
    if (!e.target.classList.contains("combined-cart__master")) {
      this.updateVariant(e.target.id.split("_")[0].split("-")[1]);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.available) return;

    const items = Object.entries(this.selectedProducts).map((product) => {
      return { id: product[1].id, quantity: 1 };
    });

    const event = new CustomEvent("cart:add", {
      detail: {
        submitter: e.submitter,
        data: {
          items,
        },
      },
      bubbles: true,
    });

    this.dispatchEvent(event);
  }

  updateVariant(pid) {
    const formData = new FormData(this.form);
    const selected = [];
    for (const [key, value] of formData.entries()) {
      if (key.includes(pid)) {
        selected.push(value);
      }
    }
    const data = JSON.parse(this.querySelector(`.product-${pid}_data`).innerHTML);
    const variantMatch = data.variants.filter((variant) => {
      return (
        variant.option1 === selected[0] &&
        (variant.option2 ? variant.option2 === selected[1] : true) &&
        (variant.option3 ? variant.option3 === selected[2] : true)
      );
    });

    if (variantMatch.length > 0) {
      this.selectedProducts[pid] = variantMatch[0];
      this.querySelector(`#product-${pid} .combined-cart__product-price`).innerHTML =
        theme.Currency.formatMoney(variantMatch[0].price, theme.moneyFormat);
    } else {
      this.selectedProducts[pid] = null;
    }
    this.updateAction();
  }

  updateAction() {
    let available = true;
    let unavailable = false;
    let total = 0;
    for (const [key, value] of Object.entries(this.selectedProducts)) {
      if (!value) {
        unavailable = true;
      } else if (!value.available && available === true) {
        available = false;
        total += value.price;
      } else {
        total += value.price;
      }
    }
    if (unavailable) {
      this.submitter.innerHTML = theme.strings.combined.unavailable;
      this.available = false;
      this.submitter.disabled = true;
      return;
    } else if (available) {
      this.submitter.innerHTML = theme.strings.combined.available;
      this.available = true;
      this.submitter.disabled = false;
    } else {
      this.submitter.innerHTML = theme.strings.combined.nostock;
      this.available = false;
      this.submitter.disabled = true;
    }
    this.querySelector(".combined-cart__value").innerHTML = theme.Currency.formatMoney(
      total,
      theme.moneyFormat,
    );
  }
}
customElements.define("combined-cart", CombinedCart);

// FAQ Functionaility
const toggleFAQ = (e) => {
  var parentEl = e.target.classList.contains("mphus-faq__container")
    ? e.target
    : e.target.closest(".mphus-faq__container");
  var answerEl = parentEl.querySelector(".faq-answer");
  if (parentEl.classList.contains("q-active")) {
    parentEl.classList.remove("q-active");
    answerEl.style.height = "0px";
  } else {
    parentEl.classList.add("q-active");
    answerEl.style.height = answerEl.scrollHeight + "px";
  }
};

async function cartAddItem(e) {
  const submitter = e.detail.submitter;
  const submitterInnerHTML = submitter.innerHTML;
  if (submitter) {
    submitter.classList.add("btn-elem--loading");
  }
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(e.detail.data), // expects {items: [{...}]}
    });
    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
    }
    if (!res.ok) {
      throw new Error("[cart:add] - Something went wrong");
    }
    const data = await res.json();
    theme.Notify.open("success", false, true);
    document.dispatchEvent(new CustomEvent("cart:get"));
  } catch (error) {
    console.log(error);
    theme.Notify.open("error", error, true);
  }
}

async function getCart() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw new Error("[cart:get] - Something went wrong");
    }
    const data = await res.json();
    const bubbles = document.querySelectorAll(".site-header__cart-indicator");
    bubbles.forEach((bubble) => {
      bubble.innerHTML = data.item_count;
      if (data.item_count > 0) {
        bubble.classList.remove("hide");
      } else {
        bubble.classList.add("hide");
      }
    });
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { data } }));
  } catch (error) {
    console.log(error);
  }
}

document.addEventListener("cart:add", cartAddItem);
document.addEventListener("cart:get", getCart);

// SEO Functionaility
const toggleSEO = (e) => {
  var parentEl = e.target.classList.contains(".seo-dynamic__container")
    ? e.target
    : e.target.closest(".seo-dynamic__container");
  var answerEl = parentEl.querySelector(".seo-dynamic__description");
  if (parentEl.classList.contains("q-active")) {
    parentEl.classList.remove("q-active");
    answerEl.style.height = "0px";
  } else {
    parentEl.classList.add("q-active");
    answerEl.style.height = answerEl.scrollHeight + "px";
  }
};

// Product Recommendations Small
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.limit = this.getAttribute("limit") || "8";
    this.intent = this.getAttribute("intent") || "related";
    this.product_id = this.getAttribute("product_id");
    this.section_id = this.getAttribute("section_id");
    this.options = JSON.parse(this.querySelector(".rec-wrapper").dataset.carouselOptions);
    this.wrapper = this.querySelector(".rec-wrapper");
  }
  connectedCallback() {
    this.initRecs();
  }
  addEventListeners() {}

  async initRecs() {
    const base_url = `${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${this.product_id}&limit=${this.limit}`;
    if (this.intent === "both") {
      const complementary = await this.fetchRecs(`${base_url}&intent=complementary`);
      if (complementary) {
        this.renderRecs(complementary.innerHTML);
      } else {
        const related = await this.fetchRecs(`${base_url}&intent=related`);
        if (related) {
          this.renderRecs(related.innerHTML);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recs = await this.fetchRecs(`${base_url}&intent=${this.intent}`);
      if (recs) {
        this.renderRecs(recs.innerHTML);
      } else {
        this.style.display = "none";
      }
    }
  }

  async fetchRecs(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      const container = document.createElement("div");
      container.innerHTML = data;
      const allProducts = container.querySelectorAll(".product-item__wrapper");
      if (allProducts.length > 0) {
        const recWrapper = container.querySelector(".rec-wrapper");
        return recWrapper;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  renderRecs(data) {
    this.wrapper.innerHTML = data;
    this.buildSlideShow();
  }

  buildSlideShow() {
    new Swiper(this.wrapper, this.options);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.key = this.getAttribute("key") || null;
    this.quantity = parseInt(this.querySelector('input[name="quantity"]').value) || 1;
    this.minusButton = this.querySelector(".quantity__button--minus");
    this.plusButton = this.querySelector(".quantity__button--plus");
    this.quantityInput = this.querySelector(".quantity__input");
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler);
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler);
  }

  clickHandler(e) {
    if (e.target == this.minusButton) {
      if (this.quantity - 1 <= 0) return;
      this.quantity = this.quantity - 1;
    } else if (e.target == this.plusButton) {
      this.quantity = this.quantity + 1;
    }

    this.setAttribute("quantity", this.quantity);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  static get observedAttributes() {
    return ["quantity"];
  }

  attributeChangedCallback(name, prev, next) {
    if (name === "quantity" && prev !== next) {
      this.quantity = parseInt(next);
      this.minusButton.setAttribute(
        "aria-label",
        `Reduce quantity to ${this.quantity - 1 < 1 ? this.quantity : this.quantity - 1}`,
      );
      this.plusButton.setAttribute("aria-label", `Increase quantity to ${this.quantity + 1}`);
      this.quantityInput.value = this.quantity;

      const quantityChangeEvent = new CustomEvent("quantity:change", {
        detail: {
          quantity: this.quantity,
        },
        bubbles: true,
      });
      this.dispatchEvent(quantityChangeEvent);

      if (!this.key) return;

      const event = new CustomEvent("line:change", {
        detail: {
          key: this.key,
          quantity: this.quantity,
        },
        bubbles: true,
      });
      this.dispatchEvent(event);
    }
  }
}

customElements.define("quantity-selector", QuantitySelector);

class MainCart extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector(".main-cart__summary");
    this.sticky_summary = this.querySelector(".main-cart__sticky-summary");
    this.checkout_buttons = this.querySelectorAll('.btn-elem[type="submit"]');
    this.changing_lines = [];
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("line:change", this.changeLine.bind(this));
    this.addEventListener("line:update", this.renderCart.bind(this));
    this.addEventListener("cart:update", this.renderCart.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
    this.giftNote = this.querySelector(".main-cart__gift-checkbox");
    this.noteInput = this.querySelector("#main-cart__gift-input");
    if (this.giftNote) {
      this.giftNote.addEventListener("input", this.changeHandler.bind(this));
    }
    if (this.noteInput) {
      this.noteInput.addEventListener("input", this.changeHandler.bind(this));
    }
    if (!this.sticky_summary) return;
    window.addEventListener("scroll", this.scrollHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.classList.contains("main-cart__remove")) {
      e.preventDefault();
      this.removeLine(e);
    }
  }
  changeHandler(e) {
    if (!this.noteInput) return;
    if (e.target == this.giftNote) {
      if (e.target.checked) {
        this.updateNote("add");
      } else {
        this.noteInput.value = "";
        this.updateNote("clear");
      }
    } else if (e.target == this.noteInput) {
      this.debounce(() => this.updateNote("add"));
    }
  }
  scrollHandler(e) {
    if (window.innerWidth < 768) {
      if (this.summary.getBoundingClientRect().bottom < 0) {
        this.sticky_summary.classList.add("sticky-active");
      } else {
        this.sticky_summary.classList.remove("sticky-active");
      }
    }
  }

  async updateNote(type) {
    try {
      const reqBody = {
        note: type === "add" ? this.noteInput.value : "",
      };
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reqBody),
      });
      if (!res.ok) {
        throw new Error("Error clearing cart note");
      }
      const data = await res.json();
    } catch (error) {
      console.log(error);
    }
  }

  async renderCart() {
    const cart_lines_selector = ".main-cart__items";
    const cart_subtotal_selector = ".main-cart__subtotal";
    const ctl_selector = ".main-cart__mixmatch";
    const subtotal_els = this.querySelectorAll(cart_subtotal_selector);
    const cart_lines = this.querySelector(cart_lines_selector);
    const ctls = this.querySelectorAll(ctl_selector);
    const html = await this.fetchLinesHTML();
    const html_container = document.createElement("div");
    html_container.innerHTML = html;
    if (!html_container.querySelector(cart_lines_selector)) {
      this.closest(".cart-template").innerHTML = html_container.innerHTML;
      return;
    }
    cart_lines.innerHTML = html_container.querySelector(cart_lines_selector).innerHTML;
    for (const subtotal of subtotal_els) {
      subtotal.innerHTML = html_container.querySelector(cart_subtotal_selector).innerHTML;
    }
    for (const ctl of ctls) {
      ctl.innerHTML = html_container.querySelector(ctl_selector).innerHTML;
    }
  }

  async fetchLinesHTML() {
    const section_id = "cart-template";
    try {
      const res = await fetch(`/cart?section_id=${section_id}`);
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.text();
      const html = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".shopify-section").innerHTML;
      return html;
    } catch (error) {
      console.log(error);
    }
  }
  changeLine(e) {
    const key = e.detail.key;
    const quantity = e.detail.quantity;

    this.changing_lines.push({ key, quantity });

    this.debounce(() => this.updateLines());
  }

  removeLine(e) {
    const line = e.target.closest(".main-cart__item");
    const key = line.dataset.key;
    line.classList.add("main-cart__removing");

    this.changing_lines.push({ key, quantity: 0 });
    this.debounce(() => this.updateLines());
  }

  async updateLines() {
    for (const button of this.checkout_buttons) {
      button.classList.add("btn-elem--loading");
    }
    let updates = {};

    for (const line of this.changing_lines) {
      updates[line.key] = line.quantity;
    }
    try {
      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      this.changing_lines = [];
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      const event = new CustomEvent("line:update", {
        detail: {
          data,
        },
      });
      this.dispatchEvent(event);
    } catch (error) {
      console.log(error);
    } finally {
      const event = new CustomEvent("cart:get");
      document.dispatchEvent(event);

      for (const button of this.checkout_buttons) {
        button.classList.remove("btn-elem--loading");
      }
    }
  }

  debounce(fn, wait = 500) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}

customElements.define("main-cart", MainCart);

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
      this.elements.swiper.dataset.alignArrows
        ? (this.align_arrows = JSON.parse(this.elements.swiper.dataset.alignArrows))
        : null;
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }

  addEventListeners() {
    window.addEventListener("resize", this.positionArrows.bind(this));
  }

  init() {}

  positionArrows() {
    setTimeout(() => {
      if (!this.align_arrows || !this.elements.prevButton || !this.elements.nextButton) return;
      const slide_image_height = this.swiper.slidesEl.querySelector(".luc-media")?.offsetHeight;
      this.elements.nextButton.style.top = slide_image_height / 2 + "px";
      this.elements.nextButton.style.marginTop = -this.elements.nextButton.offsetHeight / 2 + "px";
      this.elements.prevButton.style.top = slide_image_height / 2 + "px";
      this.elements.prevButton.style.marginTop = -this.elements.prevButton.offsetHeight / 2 + "px";
    }, 1);
  }
}
customElements.define("main-carousel", MainCarousel);

class RecentlyViewedCarousel extends MainCarousel {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".main-carousel__wrapper").innerHTML;
    const item_wrapper = this.querySelector(".main-carousel__wrapper");
    item_wrapper.innerHTML = items;
    this.init();
  }
}
customElements.define("recently-viewed-carousel", RecentlyViewedCarousel);

class GeoLocationModal extends HTMLElement {
  constructor() {
    super();
    this.dismissedKey = "hh_uk_geo_modal_dismissed_until";
    this.sessionHandledKey = "hh_uk_geo_modal_handled";
    this.ukTimezones = ["Europe/London", "Europe/Jersey", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Dublin"];
    this.timezoneCountries = {
      "America/Santiago": "chile",
      "Asia/Seoul": "south-korea",
      "Asia/Tokyo": "japan",
      "Atlantic/Canary": "spain",
      "Europe/Amsterdam": "rest-of-europe",
      "Europe/Athens": "rest-of-europe",
      "Europe/Berlin": "germany",
      "Europe/Bratislava": "slovakia",
      "Europe/Brussels": "rest-of-europe",
      "Europe/Budapest": "hungary",
      "Europe/Busingen": "germany",
      // "Europe/Dublin": "ireland",
      "Europe/Madrid": "spain",
      "Europe/Paris": "france",
      "Europe/Prague": "czechia",
      "Europe/Rome": "italy",
      "Europe/Vienna": "rest-of-europe",
      "Europe/Warsaw": "poland",
      "Pacific/Easter": "chile",
    };
    this.timezonePrefixes = [{ prefix: "Australia/", country: "australia" }];
    this.lastFocusedElement = null;
    this.events = [
      {
        el: this,
        type: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: document,
        type: "keydown",
        callback: this.keyboardHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.modal = this.querySelector(".geolocation-modal");

    if (!this.modal) {
      return;
    }

    handleEventListeners(this.events);

    try {
      if (sessionStorage.getItem(this.sessionHandledKey) === "true") {
        return;
      }
    } catch (error) {
      // Storage can be blocked; continue with timezone detection.
    }

    try {
      const dismissedUntil = Number(localStorage.getItem(this.dismissedKey));
      if (dismissedUntil && dismissedUntil > Date.now()) {
        return;
      }
    } catch (error) {
      // Storage can be blocked; continue with timezone detection.
    }

    let timezone = "";
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch (error) {
      return;
    }

    if (timezone && !this.ukTimezones.includes(timezone)) {
      this.renderStoreRecommendation(this.getCountryFromTimezone(timezone));

      window.setTimeout(() => {
        this.lastFocusedElement = document.activeElement;
        this.modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("geolocation-modal-open");
        this.querySelector("button")?.focus();
      }, 700);
    }
  }

  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  clickHandler(event) {
    if (event.target.closest("[data-geo-modal-store-link]")) {
      try {
        sessionStorage.setItem(this.sessionHandledKey, "true");
      } catch (error) {
        // Storage can be blocked; still let the customer continue.
      }
      return;
    }

    if (event.target.closest("[data-geo-modal-redirect]")) {
      try {
        sessionStorage.setItem(this.sessionHandledKey, "true");
      } catch (error) {
        // Storage can be blocked; still let the customer continue.
      }
      window.location.href = this.dataset.redirectUrl || "/pages/international";
      return;
    }

    if (event.target.closest("[data-geo-modal-close]") || event.target === this.modal) {
      this.dismiss();
    }
  }

  dismiss() {
    try {
      const cooldownDays = Number(this.dataset.cooldownDays) || 30;
      const dismissedUntil = Date.now() + cooldownDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.dismissedKey, String(dismissedUntil));
    } catch (error) {
      // Storage can be blocked; closing the modal should still work.
    }
    this.modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("geolocation-modal-open");

    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === "function") {
      this.lastFocusedElement.focus();
    }
  }

  keyboardHandler(event) {
    if (this.modal.getAttribute("aria-hidden") === "true") {
      return;
    }

    if (event.key === "Escape") {
      this.dismiss();
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusableElements = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!firstElement || !lastElement) {
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  getCountryFromTimezone(timezone) {
    if (!timezone) {
      return "";
    }

    if (this.timezoneCountries[timezone]) {
      return this.timezoneCountries[timezone];
    }

    const prefixMatch = this.timezonePrefixes.find((item) => timezone.indexOf(item.prefix) === 0);

    if (prefixMatch) {
      return prefixMatch.country;
    }

    return "";
  }

  renderStoreRecommendation(country) {
    const recommendation = this.querySelector("[data-geo-store-recommendation]");
    const body = this.querySelector("[data-geo-modal-body]");
    const storeLink = this.querySelector("[data-geo-modal-store-link]");

    if (!recommendation) {
      return;
    }

    recommendation.hidden = true;
    if (body) {
      body.hidden = false;
    }
    if (storeLink) {
      storeLink.hidden = true;
      storeLink.removeAttribute("href");
    }
    recommendation.querySelectorAll("[data-geo-store-candidate]").forEach((candidate) => {
      candidate.hidden = true;
    });

    if (!country) {
      return;
    }

    const candidate = recommendation.querySelector('[data-geo-store-candidate="' + country + '"]');

    if (!candidate) {
      return;
    }

    candidate.hidden = false;
    recommendation.hidden = false;

    if (body) {
      body.hidden = true;
    }

    if (storeLink) {
      storeLink.href = candidate.dataset.geoStoreUrl || "#";
      storeLink.textContent = "Shop Heat Holders " + (candidate.dataset.geoStoreName || "");
      storeLink.hidden = false;
    }
  }
}

customElements.define("geo-location-modal", GeoLocationModal);

class PopupDialog extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }
  clickHandler(e) {
    const action_target =
      e.target.closest("[modal-dialog-action]")?.getAttribute("modal-dialog-action") || null;
    if (action_target === "open") {
      e.preventDefault();
      this.openModal();
    } else if (action_target === "close" || !e.target.closest(".modal-main__inner")) {
      e.preventDefault();
      this.closeModal();
    }
  }
  keyboardHandler(e) {
    if ((e.key === "Escape" || e.keyCode === 27) && this.is_open === true) {
      this.closeModal();
    }
  }
  openModal() {
    this.is_open = true;
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("modal-dialog-view", "visible");
  }
  closeModal() {
    this.is_open = false;
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("modal-dialog-view", "hidden");
  }
}

customElements.define("popup-dialog", PopupDialog);

class RepeatOrder extends PopupDialog {
  constructor() {
    super();

    this.main_message = this.querySelector("[modal-repeat-order-message]");
    this.unavailable_message = this.querySelector("[modal-unavailable-message]");
    this.alternative_message = this.querySelector("[modal-alternative-message]");
  }

  addEventListeners() {
    super.addEventListeners();
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.getAttribute("modal-dialog-action") === "open") {
      if (!this.unavailable_message) {
        this.triggerReorder();
      }
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-clear") {
      this.toggleMessage();
      this.clearCart();
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-combine") {
      this.toggleMessage();
      this.continueReorder();
    }
  }

  async triggerReorder() {
    const cart_check = await this.checkCart();
    if (!cart_check) {
      this.toggleMessage("alt");
    } else {
      this.continueReorder();
    }
  }

  async checkCart() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      if (data.item_count > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async continueReorder() {
    const form_inputs = this.querySelectorAll("form input");
    const form_data = {};
    for (const input of form_inputs) {
      let current = 0;
      if (form_data[input.dataset.id]?.quantity) {
        current = form_data[input.dataset.id].quantity;
      }
      form_data[input.dataset.id] = { properties: {} };
      form_data[input.dataset.id].quantity = current + +input.dataset.quantity;
    }
    const item_data = { items: [] };
    for (const [key, value] of Object.entries(form_data)) {
      item_data.items.push({
        id: +key,
        quantity: value.quantity,
        properties: { ...value.properties },
      });
    }
    let event;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(item_data),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      event = new CustomEvent("cart:add:success", {
        detail: {
          type: "success",
          data: {
            title: "Order",
          },
        },
      });
      window.location.href = "/cart";
    } catch (error) {
      console.log(error);
      event = new CustomEvent("cart:add:error", {
        detail: {
          type: "error",
          error,
        },
      });
    } finally {
      document.dispatchEvent(event);
      this.closeModal();
    }
  }

  async clearCart() {
    try {
      const res = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
    this.continueReorder();
  }

  closeModal() {
    super.closeModal();
    this.toggleMessage();
  }

  toggleMessage(type) {
    if (type === "alt") {
      this.main_message.setAttribute("aria-hidden", "true");
      this.alternative_message.setAttribute("aria-hidden", "false");
    } else {
      this.main_message.setAttribute("aria-hidden", "false");
      this.alternative_message.setAttribute("aria-hidden", "true");
    }
  }
}
customElements.define("repeat-order", RepeatOrder);

class CartAddForm extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("submit", globalAddItemFromForm);
  }

  removeEventListeners() {
    this.removeEventListener("submit", globalAddItemFromForm);
  }

  submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const event = new CustomEvent("cart:add:submit", {
      detail: {
        data: formData,
        submitter: e.submitter,
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("cart-add-form", CartAddForm);
